import { getBlogImageForPost } from './blogImages.js';

const sourceLibrary = {
  nhsHomecare: {
    title: 'NHS: Help at home from a paid carer',
    url: 'https://www.nhs.uk/social-care-and-support/care-services-equipment-and-care-homes/homecare/',
  },
  nhsAssessment: {
    title: 'NHS: Getting a care needs assessment',
    url: 'https://www.nhs.uk/social-care-and-support/help-from-social-services-and-charities/getting-a-needs-assessment/',
  },
  nhsCarePlan: {
    title: 'NHS: Care and support plans',
    url: 'https://www.nhs.uk/social-care-and-support/help-from-social-services-and-charities/care-and-support-plans/',
  },
  nhsReablement: {
    title: 'NHS: Care after hospital discharge and reablement',
    url: 'https://www.nhs.uk/social-care-and-support/care-after-a-hospital-stay/care-to-support-recovery-after-leaving-hospital-or-after-a-fall-injury-or-illness/',
  },
  nhsCarers: {
    title: "NHS: Carer's assessments",
    url: 'https://www.nhs.uk/social-care-and-support/support-and-benefits-for-carers/carer-assessments/',
  },
  cqcGoodHomecare: {
    title: 'CQC: What to expect from a good home-care agency',
    url: 'https://www.cqc.org.uk/care-services/what-expect-good-care-service/what-can-you-expect-good-home-care-agency',
  },
  cqcChoosingCare: {
    title: 'CQC: Help choosing care',
    url: 'https://www.cqc.org.uk/care-services/help-choosing-care',
  },
  govCareAct: {
    title: 'GOV.UK: Care and support statutory guidance',
    url: 'https://www.gov.uk/government/publications/care-act-statutory-guidance/care-and-support-statutory-guidance',
  },
  homecareAssociation: {
    title: 'Homecare Association: Choosing care at home',
    url: 'https://www.homecareassociation.org.uk/find-care/choosing-care-at-home.html',
  },
  homecareWorkforce: {
    title: 'Homecare Association: Voices of Homecare - Workforce',
    url: 'https://www.homecareassociation.org.uk/resource/voices-of-homecare-workforce.html',
  },
  ageUkProblems: {
    title: 'Age UK: Problems with homecare',
    url: 'https://www.ageuk.org.uk/information-advice/care/problems-with-care/problems-with-homecare/',
  },
  whichPayingCare: {
    title: 'Which?: Paying for care at home',
    url: 'https://www.which.co.uk/money/pensions-and-retirement/financing-later-life-care/paying-for-care-at-home-aLGNI2T1NhwY',
  },
};

const calendarWeeks = [
  {
    week: 1,
    tuesday: 'When Is It Time to Consider Home Care? A UK Family Checklist',
    thursday: 'Home Care, Home Help and Companionship: What Each Actually Means',
    weekend: null,
    cta: 'Download the "Is It Time for Support?" checklist',
  },
  {
    week: 2,
    tuesday: 'How to Start a Care Needs Assessment in England',
    thursday: '20 Questions to Ask a Home Care Agency Before You Sign',
    weekend: 'North Tyneside Home Care: How Families Can Compare Options',
    cta: 'Use the provider comparison worksheet',
  },
  {
    week: 3,
    tuesday: 'What Goes Into a Good Care and Support Plan',
    thursday: 'Short Visits vs Longer Visits: How to Choose the Right Pattern',
    weekend: null,
    cta: 'Prepare with the care-plan template',
  },
  {
    week: 4,
    tuesday: 'How Much Does Home Care Cost in the UK and What Affects Price?',
    thursday: 'Agency Carer vs Private Carer: Responsibilities Families Should Understand',
    weekend: 'Staff: What Does a Care Assistant Actually Do in a Home Care Role?',
    cta: 'Compare care costs with transparent quote questions',
  },
  {
    week: 5,
    tuesday: 'Care at Home vs Moving to a Care Home: Questions Families Can Work Through',
    thursday: 'How to Talk to a Parent Who Is Nervous About Help at Home',
    weekend: null,
    cta: 'Use the family conversation guide',
  },
  {
    week: 6,
    tuesday: 'CQC Ratings for Home Care: How to Read Them Without Panicking',
    thursday: 'What Good Home Care Should Feel Like: Safe, Caring, Responsive and Well Led',
    weekend: 'Newcastle Home Care: Finding Reliable Support Around Busy Family Routines',
    cta: 'Review providers with the CQC checklist',
  },
  {
    week: 7,
    tuesday: 'What to Expect at the First Home Care Assessment',
    thursday: 'How Families Can Prepare an About Me Care Profile',
    weekend: null,
    cta: 'Create an About Me care profile',
  },
  {
    week: 8,
    tuesday: 'Understanding Direct Payments and Personal Budgets in Plain English',
    thursday: 'Self-Funding Home Care: How to Budget Without Hidden Surprises',
    weekend: 'Staff: DBS, References and Training: What New Care Workers Should Expect',
    cta: 'Ask clearer funding and setup questions',
  },
  {
    week: 9,
    tuesday: 'Why Continuity of Carers Matters and What to Ask Providers',
    thursday: 'What to Do If Care Visits Are Late, Rushed or Missed',
    weekend: null,
    cta: 'Use the continuity and reliability scorecard',
  },
  {
    week: 10,
    tuesday: 'Respite Care at Home: How Family Carers Can Take a Proper Break',
    thursday: "Carer's Assessments: What Unpaid Family Carers Can Ask For",
    weekend: 'Gateshead Home Care: A Practical Guide for Comparing Providers',
    cta: 'Plan respite with the family carer worksheet',
  },
  {
    week: 11,
    tuesday: 'After Hospital Discharge: How Reablement and Ongoing Home Care Differ',
    thursday: 'Building a Safer Morning and Evening Routine at Home',
    weekend: null,
    cta: 'Prepare discharge-to-home questions',
  },
  {
    week: 12,
    tuesday: 'Personal Care at Home: Dignity, Choice and Consent Explained',
    thursday: 'Medication Prompts vs Medication Advice: Where Home Care Boundaries Sit',
    weekend: 'Staff: From Retail or Hospitality to Care: Transferable Skills That Matter',
    cta: 'Record personal-care preferences before care starts',
  },
  {
    week: 13,
    tuesday: 'Companionship Care: When Loneliness Is the Main Concern',
    thursday: 'How to Help an Older Relative Stay Connected Locally',
    weekend: null,
    cta: 'Build a weekly companionship planner',
  },
  {
    week: 14,
    tuesday: 'Live-In Care: Who It Suits, What It Includes and What to Clarify',
    thursday: 'Night Care, Sleeping Nights and Waking Nights: Family Guide',
    weekend: 'Hexham Home Care: Planning Support Around Rural Travel and Routines',
    cta: 'Ask the live-in and night-care questions',
  },
  {
    week: 15,
    tuesday: 'Dementia Support at Home: Routine, Familiarity and Family Communication',
    thursday: 'Making a Home More Dementia-Friendly Without Major Building Work',
    weekend: null,
    cta: 'Use the dementia routine and environment checklist',
  },
  {
    week: 16,
    tuesday: 'How to Compare Home Care Contracts Before You Agree',
    thursday: 'What Should Be in a Home Care Welcome Pack?',
    weekend: 'Staff: A Day in the Life of a Visiting Care Assistant',
    cta: 'Read the contract review checklist',
  },
  {
    week: 17,
    tuesday: 'Emergency Planning for Home Care: Keys, Contacts and Backup Plans',
    thursday: 'Key Safes and Home Access: Practical Questions Families Should Ask',
    weekend: null,
    cta: 'Complete the emergency contact sheet',
  },
  {
    week: 18,
    tuesday: 'Nutrition Support at Home: Meal Routines, Shopping Lists and Hydration Reminders',
    thursday: 'Gentle Activity at Home: Safe Movement Support Without Giving Medical Advice',
    weekend: 'Corbridge and Riding Mill Home Care: Planning Care in Village Settings',
    cta: 'Create a meal and daily routine planner',
  },
  {
    week: 19,
    tuesday: 'How to Choose Visit Times That Match Real Life',
    thursday: 'What Families Should Tell a New Carer on Day One',
    weekend: null,
    cta: 'Use the day-one handover template',
  },
  {
    week: 20,
    tuesday: 'How Care Reviews Work and When to Ask for One',
    thursday: 'Changing Needs: When to Increase, Reduce or Redesign a Care Package',
    weekend: 'Staff: Why Values Matter in Care Recruitment',
    cta: 'Prepare a care review agenda',
  },
  {
    week: 21,
    tuesday: 'Safeguarding Adults at Home: What Families Should Know',
    thursday: 'Financial Abuse, Pressure and Scams: Home Care Conversation Starters',
    weekend: null,
    cta: 'Save safeguarding signposting information',
  },
  {
    week: 22,
    tuesday: 'Attendance Allowance and PIP: Benefits That May Help With Care Costs',
    thursday: 'NHS Continuing Healthcare: What Families Can Read Before Asking Questions',
    weekend: 'Stocksfield and Prudhoe Home Care: Local Support Planning Guide',
    cta: 'Review benefits and funding signposts',
  },
  {
    week: 23,
    tuesday: 'Family Care Notes: How to Keep Everyone on the Same Page',
    thursday: 'When Siblings Disagree About Care: A Practical Meeting Agenda',
    weekend: null,
    cta: 'Run a calmer family care meeting',
  },
  {
    week: 24,
    tuesday: 'Choosing Care for Someone Who Refuses Help: Respectful First Steps',
    thursday: 'How to Introduce a Carer Without Making It Feel Like a Big Event',
    weekend: 'Staff: What Makes Someone a Strong Companionship Carer?',
    cta: 'Plan a gentle first introduction',
  },
  {
    week: 25,
    tuesday: 'Summer Home Care Planning: Heat, Hydration and Routine Check-ins',
    thursday: 'Going Away as a Family Carer: How to Arrange Respite Cover',
    weekend: null,
    cta: 'Use the summer routine checklist',
  },
  {
    week: 26,
    tuesday: 'Home Adaptations and Equipment: What to Ask Adult Social Care or an OT',
    thursday: 'Personal Alarms, Telecare and Home Care: How They Can Work Together',
    weekend: 'Rural Northumberland Home Care: Continuity When Travel Times Matter',
    cta: 'Ask the home safety and equipment questions',
  },
  {
    week: 27,
    tuesday: 'What Families Often Forget When Arranging Care Quickly',
    thursday: 'Hospital Bag, Medication List and Care Notes: Non-Clinical Prep for Appointments',
    weekend: null,
    cta: 'Use the fast-start care checklist',
  },
  {
    week: 28,
    tuesday: 'Palliative Support at Home: Comfort, Dignity and Family Coordination',
    thursday: 'End-of-Life Conversations: Practical Questions Families Can Prepare',
    weekend: 'Staff: Working in Care With Confidence, Boundaries and Compassion',
    cta: 'Coordinate family roles and questions',
  },
  {
    week: 29,
    tuesday: 'Care for Couples at Home: Planning Shared and Separate Support',
    thursday: 'How Home Care Can Support Pets, Post and Everyday House Routines',
    weekend: null,
    cta: 'Plan support for two people at home',
  },
  {
    week: 30,
    tuesday: 'North Tyneside Care Provider Checklist: Questions for Local Families',
    thursday: 'What to Do When a Care Package Stops Feeling Right',
    weekend: 'North East Family Guide: Choosing Between Companionship, Personal Care and Live-In Care',
    cta: 'Review your current care package',
  },
  {
    week: 31,
    tuesday: 'Building Trust With a New Carer: The First Four Weeks',
    thursday: 'How Relationship Matching Can Support Comfort at Home',
    weekend: null,
    cta: 'Complete a first-four-weeks review',
  },
  {
    week: 32,
    tuesday: 'Care Quality: What Families Can Track Without Micromanaging',
    thursday: 'Complaints About Home Care: How to Document and Raise Concerns',
    weekend: 'Staff: Career Progression in Home Care: From New Starter to Senior Roles',
    cta: 'Use the care quality tracker',
  },
  {
    week: 33,
    tuesday: 'Autumn Home Care Planning: Darker Evenings, Appointments and Family Check-ins',
    thursday: 'Getting Ready for Winter: Warmth, Food, Prescriptions and Contingency Plans',
    weekend: null,
    cta: 'Prepare the autumn and winter checklist',
  },
  {
    week: 34,
    tuesday: 'Newcastle Home Care: Coordinating Support Around Work and Family Life',
    thursday: 'How to Plan Home Care Around GP, Pharmacy and Community Services',
    weekend: 'Newcastle Family Checklist: Care Visits in Flats, Terraces and Busy Streets',
    cta: 'Plan local care coordination',
  },
  {
    week: 35,
    tuesday: 'Short-Term Home Care After Illness or Injury: What Families Should Clarify',
    thursday: 'What Reablement Teams Do and When Private Home Care Might Follow',
    weekend: null,
    cta: 'Ask short-term care questions',
  },
  {
    week: 36,
    tuesday: 'What Makes a Care Plan Person-Centred?',
    thursday: 'Cultural, Faith and Personal Preferences in Home Care',
    weekend: 'Staff: Male Care Workers in Home Care: Why Representation Matters',
    cta: 'Record personal preferences clearly',
  },
  {
    week: 37,
    tuesday: 'Managing Appointments: How Home Care Can Support Travel and Reminders',
    thursday: 'How to Prepare for a Home Care Review Meeting',
    weekend: null,
    cta: 'Build an appointment support planner',
  },
  {
    week: 38,
    tuesday: 'Gateshead Home Care: Comparing Providers Beyond Star Ratings',
    thursday: 'Late Visits, Missed Calls and Continuity: What Families Should Ask Upfront',
    weekend: 'Gateshead Family Guide: Building a Backup Care Plan',
    cta: 'Prepare a backup care plan',
  },
  {
    week: 39,
    tuesday: 'When Is Companionship Enough and When Is Personal Care Needed?',
    thursday: 'Choosing a Minimum Visit Length That Still Feels Respectful',
    weekend: null,
    cta: 'Use the support-level checklist',
  },
  {
    week: 40,
    tuesday: 'Home Care for People Living Alone: Practical Safety and Connection Checks',
    thursday: 'Family Dashboards, WhatsApp Groups and Care Notes: Communication Options',
    weekend: 'Staff: Interview Preparation for Care Assistant Applicants',
    cta: 'Plan support for someone living alone',
  },
  {
    week: 41,
    tuesday: 'How to Spot a Transparent Home Care Quote',
    thursday: 'Questions About Weekend, Evening and Bank Holiday Care',
    weekend: null,
    cta: 'Compare care quotes clearly',
  },
  {
    week: 42,
    tuesday: 'Tyne Valley Home Care: Planning Around Rural Routes and Local Community Life',
    thursday: 'What Happens If a Regular Carer Is Off Sick or on Holiday?',
    weekend: 'Tyne Valley Family Guide: Continuity, Travel Time and Familiar Faces',
    cta: 'Ask about continuity cover',
  },
  {
    week: 43,
    tuesday: 'Dementia-Friendly Mealtimes: Routine, Choice and Calm',
    thursday: 'Activities at Home for Memory, Routine and Conversation',
    weekend: null,
    cta: 'Build a dementia-friendly routine planner',
  },
  {
    week: 44,
    tuesday: 'How to Make Personal Care Feel Less Embarrassing',
    thursday: 'Consent, Privacy and Dignity in Daily Support',
    weekend: 'Staff: What New Starters Should Know About Dignity in Care',
    cta: 'Write down dignity and privacy preferences',
  },
  {
    week: 45,
    tuesday: 'Preparing for Christmas Care Cover: Family Visits, Meals and Routines',
    thursday: 'Loneliness During Holidays: Planning Companionship Without Pressure',
    weekend: null,
    cta: 'Plan holiday care cover',
  },
  {
    week: 46,
    tuesday: 'Hexham Winter Home Care: Access, Weather and Backup Planning',
    thursday: 'Bad Weather and Care Visits: What Families Should Ask Providers',
    weekend: 'North East Winter Checklist for Families Using Home Care',
    cta: 'Complete winter backup planning',
  },
  {
    week: 47,
    tuesday: 'When Family Carers Burn Out: Practical Signs to Notice',
    thursday: 'Respite Without Guilt: How to Frame It as Better Care',
    weekend: null,
    cta: 'Use the family carer wellbeing checklist',
  },
  {
    week: 48,
    tuesday: 'How to Choose Home Care for a Parent Living With Dementia',
    thursday: 'What to Ask About Carer Training and Supervision',
    weekend: 'Staff: Why Home Care Needs Calm, Reliable Communicators',
    cta: 'Ask dementia care provider questions',
  },
  {
    week: 49,
    tuesday: 'New Year Care Planning: Reviewing What Worked Last Year',
    thursday: 'How to Set Care Goals That Are Practical and Personal',
    weekend: null,
    cta: 'Start a new-year care review',
  },
  {
    week: 50,
    tuesday: 'North East Home Care: Questions Families Ask Before Booking a First Visit',
    thursday: 'What Good Family Updates Should Include',
    weekend: 'Holiday-to-New-Year Care Transitions: Keeping Routine Steady',
    cta: 'Prepare for a first visit',
  },
  {
    week: 51,
    tuesday: 'Care at Home FAQs: Honest Answers to Common Family Concerns',
    thursday: 'What Families Should Know Before Requesting Care at Short Notice',
    weekend: null,
    cta: 'Use the short-notice readiness list',
  },
  {
    week: 52,
    tuesday: 'The Complete Family Checklist for Choosing a Home Care Provider',
    thursday: 'How to Review Your Home Care Provider After Three Months',
    weekend: 'Staff: Why Join KCG: What Applicants Should Expect From the Process',
    cta: 'Use the annual provider checklist',
  },
];

const includesAny = (value, terms) => terms.some((term) => value.includes(term));

const slugify = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

const getTextSeed = (value) =>
  Math.abs(
    String(value || '').split('').reduce((hash, char) => {
      const next = (hash << 5) - hash + char.charCodeAt(0);
      return next & next;
    }, 0)
  );

const cleanTitle = (title) => title.replace(/^Staff:\s*/, '');

const inferCategory = (title) => {
  const value = title.toLowerCase();

  if (value.startsWith('staff:')) return 'Care Careers';
  if (
    includesAny(value, [
      'north tyneside',
      'newcastle',
      'gateshead',
      'hexham',
      'corbridge',
      'riding mill',
      'stocksfield',
      'prudhoe',
      'north east',
      'northumberland',
      'tyne valley',
    ])
  ) {
    return 'Local Home Care';
  }
  if (
    includesAny(value, [
      'cost',
      'price',
      'budget',
      'direct payment',
      'personal budget',
      'self-funding',
      'attendance allowance',
      'pip',
      'nhs continuing healthcare',
      'funding',
      'quote',
    ])
  ) {
    return 'Funding & Planning';
  }
  if (
    includesAny(value, [
      'cqc',
      'provider',
      'agency',
      'contract',
      'complaints',
      'quality',
      'questions',
      'compare',
      'rating',
      'late visits',
      'missed',
    ])
  ) {
    return 'Choosing Care';
  }
  if (value.includes('dementia') || value.includes('memory')) return 'Dementia Care';
  if (
    includesAny(value, [
      'safety',
      'safe',
      'key safe',
      'alarm',
      'telecare',
      'adaptations',
      'equipment',
      'winter',
      'weather',
      'safeguarding',
      'scams',
      'emergency',
    ])
  ) {
    return 'Home Safety';
  }
  if (
    includesAny(value, [
      'family',
      'carer',
      'carers',
      'respite',
      'siblings',
      'burn out',
      'guilt',
      'meeting',
      'notes',
    ])
  ) {
    return 'Family Support';
  }
  if (
    includesAny(value, ['hospital', 'discharge', 'reablement', 'illness', 'injury', 'appointments'])
  ) {
    return 'Hospital to Home';
  }
  if (
    includesAny(value, ['personal care', 'medication', 'consent', 'privacy', 'dignity'])
  ) {
    return 'Personal Care';
  }
  if (includesAny(value, ['companionship', 'loneliness', 'connected locally'])) return 'Companionship';
  if (includesAny(value, ['live-in', 'night care', 'sleeping night', 'waking night'])) {
    return 'Live-in & Night Care';
  }
  if (includesAny(value, ['nutrition', 'meal', 'hydration', 'activity'])) return 'Wellbeing at Home';

  return 'Care Advice';
};

const getSourcesForPost = (title, category) => {
  const value = title.toLowerCase();
  const sources = [sourceLibrary.nhsHomecare, sourceLibrary.cqcGoodHomecare];

  if (category === 'Care Careers') {
    return [sourceLibrary.homecareWorkforce, sourceLibrary.cqcGoodHomecare];
  }
  if (category === 'Local Home Care') {
    sources.push(sourceLibrary.cqcChoosingCare, sourceLibrary.homecareAssociation);
  }
  if (category === 'Funding & Planning') {
    sources.push(sourceLibrary.nhsAssessment, sourceLibrary.nhsCarePlan, sourceLibrary.whichPayingCare);
  }
  if (category === 'Choosing Care') {
    sources.push(sourceLibrary.cqcChoosingCare, sourceLibrary.homecareAssociation);
  }
  if (category === 'Family Support') {
    sources.push(sourceLibrary.nhsCarers, sourceLibrary.nhsCarePlan);
  }
  if (category === 'Hospital to Home') {
    sources.push(sourceLibrary.nhsReablement, sourceLibrary.nhsCarePlan);
  }
  if (category === 'Dementia Care') {
    sources.push(sourceLibrary.nhsHomecare, sourceLibrary.cqcGoodHomecare);
  }
  if (value.includes('complaint') || value.includes('late') || value.includes('missed')) {
    sources.push(sourceLibrary.ageUkProblems);
  }
  if (value.includes('direct payment') || value.includes('personal budget')) {
    sources.push(sourceLibrary.govCareAct);
  }
  if (value.includes('assessment')) {
    sources.push(sourceLibrary.nhsAssessment);
  }

  return [...new Map(sources.map((source) => [source.url, source])).values()].slice(0, 5);
};

const p = (text) => ({
  type: 'paragraph',
  children: [{ text }],
});

const h = (text) => ({
  type: 'heading',
  level: 2,
  children: [{ text }],
});

const list = (items) => ({
  type: 'list',
  format: 'unordered',
  children: items.map((text) => ({
    type: 'list-item',
    children: [{ text }],
  })),
});

const h3 = (text) => ({
  type: 'heading',
  level: 3,
  children: [{ text }],
});

const markdownToBlocks = (content) => {
  const blocks = [];
  const lines = String(content || '').split('\n');
  let paragraph = [];
  let bullets = [];

  const flushParagraph = () => {
    const text = paragraph.join(' ').trim();
    if (text) blocks.push(p(text));
    paragraph = [];
  };

  const flushBullets = () => {
    if (bullets.length) blocks.push(list(bullets));
    bullets = [];
  };

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (!trimmed) {
      flushParagraph();
      flushBullets();
      return;
    }

    if (trimmed.startsWith('### ')) {
      flushParagraph();
      flushBullets();
      blocks.push(h3(trimmed.replace(/^###\s+/, '')));
      return;
    }

    if (trimmed.startsWith('## ')) {
      flushParagraph();
      flushBullets();
      blocks.push(h(trimmed.replace(/^##\s+/, '')));
      return;
    }

    if (trimmed.startsWith('- ')) {
      flushParagraph();
      bullets.push(trimmed.replace(/^-\s+/, ''));
      return;
    }

    flushBullets();
    paragraph.push(trimmed);
  });

  flushParagraph();
  flushBullets();
  return blocks;
};

const pick = (items, seed) => items[Math.abs(seed) % items.length];

const categoryIntro = {
  'Care Careers':
    'This article is for people considering a home-care role and wanting a realistic picture of the work, expectations and values involved.',
  'Choosing Care':
    'This guide helps families compare providers calmly, using CQC expectations and practical questions rather than relying on glossy claims alone.',
  'Funding & Planning':
    'This guide explains the planning questions families can prepare before speaking with the council, a provider or an independent adviser.',
  'Local Home Care':
    'This local guide is written for families comparing care at home across KCG service areas in the North East.',
  'Home Safety':
    'This article focuses on practical home-care planning and does not replace advice from an occupational therapist, clinician or safeguarding professional.',
  'Dementia Care':
    'This is general information for families arranging care at home for someone living with dementia. It avoids medical advice and focuses on routine, communication and provider questions.',
  'Family Support':
    'This article is for relatives and unpaid carers who are trying to make care sustainable, organised and less stressful.',
  'Hospital to Home':
    'This guide helps families prepare for the practical move from hospital, short-term recovery support or reablement into ongoing help at home.',
  'Personal Care':
    'This article explains how personal care can be delivered with dignity, choice and consent in a person’s own home.',
  Companionship:
    'This guide looks at social connection, routine and confidence at home, rather than clinical treatment or mental health advice.',
  'Live-in & Night Care':
    'This guide explains the main questions families should ask before arranging live-in care, sleeping nights or waking-night support.',
  'Wellbeing at Home':
    'This article covers everyday routines such as meals, hydration reminders and gentle activity support without giving medical, dietetic or exercise advice.',
  'Care Advice':
    'This guide is for families trying to understand practical home-care choices in plain English.',
};

const openingByCategory = {
  'Care Careers': [
    'Good home care work is practical, personal and relationship-led. Before applying, it helps to understand what the role feels like in a real home, not just what appears in a job advert.',
    'People often come into care from very different backgrounds. What matters most is whether they can be reliable, respectful and calm when someone is relying on them.',
  ],
  'Choosing Care': [
    'Choosing a home care provider can feel urgent, especially when family routines are already under pressure. A better decision usually comes from slowing the process down and checking the details that affect daily life.',
    'The right provider should be able to explain how support will actually work in the home: who attends, what they do, how changes are handled and how concerns are raised.',
  ],
  'Funding & Planning': [
    'Care funding can be confusing because needs, preferences and budgets often get discussed at the same time. Separating those strands makes the conversation easier to manage.',
    'Before making decisions about care costs, families benefit from writing down what support is needed and checking which questions belong with the council, the provider or an independent adviser.',
  ],
  'Local Home Care': [
    'Local care is not just about being nearby. It is about route planning, familiar carers, backup cover and whether a provider can realistically support the person’s routine in that postcode.',
    'For families comparing local providers, the most useful questions are often practical ones: travel, access, timing, communication and what happens when plans change.',
  ],
  'Home Safety': [
    'Home safety in care is mostly about noticing small practical risks before they become bigger problems. The aim is not to make a home feel clinical, but to make daily routines easier and safer.',
    'A safer home-care setup starts with the ordinary details: keys, lighting, food, bathroom routines, emergency contacts and who should be called when something does not feel right.',
  ],
  'Dementia Care': [
    'Dementia support at home works best when the person is seen as more than their diagnosis. Familiar routines, calm communication and family knowledge all matter.',
    'Families arranging dementia support often need help turning personal knowledge into a care plan that carers can follow consistently and respectfully.',
  ],
  'Family Support': [
    'Family care can become complicated long before anyone calls it a crisis. Clear roles, regular breaks and shared notes can make support feel less reactive.',
    'When relatives are carrying most of the care, the aim is not to replace the family. It is to make the arrangement more sustainable and easier to coordinate.',
  ],
  'Hospital to Home': [
    'Coming home after illness, injury or hospital discharge can expose practical gaps quickly. Food, keys, prescriptions, equipment and appointment plans all need attention.',
    'Short-term recovery support is easier to arrange when everyone is clear about what is already being provided and what the family or care provider needs to add.',
  ],
  'Personal Care': [
    'Personal care is intimate support, so dignity and consent need to be built into the plan from the beginning. Small preferences can make a big difference to comfort.',
    'Good personal care should protect the person’s routine and privacy. The best starting point is to record what the person wants help with and what they still want to do independently.',
  ],
  Companionship: [
    'Companionship care is not just “having someone pop in”. Done well, it protects routine, confidence, conversation and connection with the wider community.',
    'When loneliness is the main concern, families should think about the shape of a good week, not just the number of visits.',
  ],
  'Live-in & Night Care': [
    'Live-in and night care can sound similar from the outside, but the expectations are very different. Families should be clear about what support is needed and when.',
    'Before arranging overnight or live-in support, it is worth clarifying routines, breaks, accommodation, backup cover and what should happen if needs increase.',
  ],
  'Wellbeing at Home': [
    'Everyday wellbeing at home often comes down to simple routines: food, drink, movement, rest and a familiar rhythm to the day.',
    'Home care can support healthy routines, but it should not replace clinical, dietetic or physiotherapy advice where specialist input is needed.',
  ],
  'Care Advice': [
    'Care decisions are easier when families focus first on the practical problem they are trying to solve at home.',
    'A useful care conversation starts with the person’s ordinary day: what is working, what is becoming difficult and what support would protect independence.',
  ],
};

const bodyFlows = {
  'Care Careers': {
    firstHeadings: ['What the role is really about', 'The work behind the job title'],
    questionHeadings: ['Questions applicants should ask', 'Before you apply, clarify this'],
    closingHeadings: ['What good support from an employer looks like', 'How KCG frames the role'],
    closing:
      'Care applicants should expect clear induction, practical training, supervision and a route for raising concerns. The role is rewarding, but it needs reliability and good boundaries.',
  },
  'Choosing Care': {
    firstHeadings: ['Look beyond the brochure', 'The details that reveal the service'],
    questionHeadings: ['Questions that expose the practical reality', 'Ask these before signing anything'],
    closingHeadings: ['Make the comparison easier', 'A calmer next step'],
    closing:
      'A useful comparison is not just about price. It should include continuity, communication, CQC information, visit timing, complaints handling and how the care plan will be reviewed.',
  },
  'Funding & Planning': {
    firstHeadings: ['Separate needs from costs', 'Start with the support required'],
    questionHeadings: ['Questions that keep the money conversation clearer', 'Before agreeing a budget'],
    closingHeadings: ['Where official guidance fits', 'Keep advice in the right place'],
    closing:
      'Funding rules and personal circumstances vary, so families should use official guidance and seek independent financial or legal advice where needed.',
  },
  'Local Home Care': {
    firstHeadings: ['Local reliability matters', 'What “local” should mean in practice'],
    questionHeadings: ['Questions for a local provider', 'Practical local details to check'],
    closingHeadings: ['Planning around the area', 'Turning local knowledge into a care plan'],
    closing:
      'A local care conversation should include travel time, access, backup cover, family updates and whether the provider already supports nearby routines.',
  },
  'Home Safety': {
    firstHeadings: ['Start with ordinary routines', 'Small details that reduce risk'],
    questionHeadings: ['Questions to work through at home', 'Access, safety and backup questions'],
    closingHeadings: ['When to involve a professional', 'Keep safety advice in the right hands'],
    closing:
      'Care providers can support practical safety routines, but equipment, mobility, safeguarding or clinical concerns may need adult social care, an occupational therapist or emergency support.',
  },
  'Dementia Care': {
    firstHeadings: ['Routine is part of the support', 'Make the care plan personal'],
    questionHeadings: ['Questions that help carers understand the person', 'What families can share before care starts'],
    closingHeadings: ['Keep clinical questions separate', 'Support without overstepping'],
    closing:
      'Home care can support routine, reassurance and family communication. Diagnosis, symptoms and medication questions should stay with the GP, memory clinic, pharmacist or NHS team.',
  },
  'Family Support': {
    firstHeadings: ['Make the family role sustainable', 'Bring the care out of people’s heads'],
    questionHeadings: ['Questions for the family meeting', 'What to agree before things become urgent'],
    closingHeadings: ['How outside support can reduce pressure', 'A better way to share responsibility'],
    closing:
      'Respite, care notes, agreed contact routes and regular reviews can make family care more sustainable without removing family involvement.',
  },
  'Hospital to Home': {
    firstHeadings: ['Plan the first few days carefully', 'The practical gap after discharge'],
    questionHeadings: ['Questions before the person comes home', 'What to confirm with discharge or care teams'],
    closingHeadings: ['If needs change quickly', 'Keep recovery support responsive'],
    closing:
      'If the home setup no longer matches the person’s needs, families should contact the relevant discharge team, adult social care or clinician rather than trying to patch the problem alone.',
  },
  'Personal Care': {
    firstHeadings: ['Dignity starts in the detail', 'Choice belongs in the care plan'],
    questionHeadings: ['Questions that protect comfort and privacy', 'Preferences to record before care begins'],
    closingHeadings: ['Where care support has limits', 'Respectful support, clear boundaries'],
    closing:
      'Care workers can follow agreed support plans and prompts, but clinical medication, wound, continence or treatment questions should go to the relevant professional.',
  },
  Companionship: {
    firstHeadings: ['Think about the shape of the week', 'Connection is practical too'],
    questionHeadings: ['Questions that make companionship personal', 'What to share with a companionship carer'],
    closingHeadings: ['When loneliness needs wider support', 'Keep connection realistic'],
    closing:
      'Companionship can support routine and confidence, but concerns about depression, self-neglect or safety should be raised with appropriate services.',
  },
  'Live-in & Night Care': {
    firstHeadings: ['Clarify the type of overnight support', 'Match the arrangement to the routine'],
    questionHeadings: ['Questions before arranging live-in or night care', 'Details that avoid confusion later'],
    closingHeadings: ['Review if nights change', 'Keep expectations clear'],
    closing:
      'If overnight needs become frequent, complex or clinical, the arrangement may need review with the provider and relevant health or social care professionals.',
  },
  'Wellbeing at Home': {
    firstHeadings: ['Keep routines realistic', 'Support the habits that already work'],
    questionHeadings: ['Questions about food, drink and activity routines', 'What families should record'],
    closingHeadings: ['Stay inside safe boundaries', 'When specialist advice is needed'],
    closing:
      'Care can support everyday routines and reminders, but nutrition, swallowing, exercise or treatment advice should come from qualified professionals.',
  },
  'Care Advice': {
    firstHeadings: ['Start with the daily routine', 'Focus on the first problem to solve'],
    questionHeadings: ['Questions that make the decision clearer', 'What to ask before arranging support'],
    closingHeadings: ['A practical next step', 'How to move from worry to a plan'],
    closing:
      'Writing down routines, preferences, risks and family contacts makes the first care conversation more useful and less rushed.',
  },
};

const categoryPracticalPoints = {
  'Care Careers': [
    'Care work depends on reliability, communication, respect for privacy and calm judgement in real homes.',
    'Applicants should expect checks, references, induction and ongoing supervision before working independently.',
    'A good provider should explain travel expectations, visit lengths, training, escalation routes and support from managers.',
  ],
  'Choosing Care': [
    'Check whether the provider is CQC registered for regulated personal care where that applies.',
    'Ask how carers are matched, introduced, supervised and covered when someone is off sick or delayed.',
    'Look for clear contracts, transparent pricing, a complaints process and realistic promises about continuity.',
  ],
  'Funding & Planning': [
    'A council care needs assessment is free and can help clarify what support is needed day to day.',
    'A care and support plan should explain what support will happen, how it will happen and how budgets are handled.',
    'Self-funding families should ask for a written price list and clarify extras, weekends, bank holidays and minimum visit lengths.',
  ],
  'Local Home Care': [
    'Local availability matters because travel time, route planning and familiar carers affect reliability.',
    'Families should compare providers on communication, backup cover, CQC information and the detail of the care plan.',
    'Rural or semi-rural areas may need extra planning around weather, access, keys and appointment travel.',
  ],
  'Home Safety': [
    'Start with practical risks around access, lighting, trip hazards, kitchen routines, bathroom routines and emergency contacts.',
    'Ask who should be contacted if a carer cannot gain access or notices a concern during a visit.',
    'For adaptations, equipment or mobility questions, ask adult social care, an occupational therapist or a relevant professional.',
  ],
  'Dementia Care': [
    'Familiar routines, clear communication and consistent carers can reduce confusion and help families notice changes.',
    'A care plan should include preferences, life history, calming routines, food and drink preferences, and family contacts.',
    'Clinical questions about symptoms, medication or diagnosis should go to a GP, memory clinic, pharmacist or NHS service.',
  ],
  'Family Support': [
    'Family carers should not wait until crisis point before asking for respite, a carer’s assessment or practical support.',
    'Shared notes, agreed responsibilities and review meetings can reduce confusion between relatives.',
    'A good provider should explain how family updates work and how concerns are escalated.',
  ],
  'Hospital to Home': [
    'Hospital discharge, reablement and private home care are different forms of support and may happen at different stages.',
    'Families should prepare practical details such as keys, food, prescriptions, equipment, appointment dates and contact numbers.',
    'If needs change quickly, ask adult social care, the discharge team or a clinician who is responsible for the person’s care.',
  ],
  'Personal Care': [
    'Personal care should protect dignity, privacy, consent and the person’s preferred routine.',
    'Families can help by documenting preferences around washing, dressing, grooming, continence support and who should be informed of concerns.',
    'Medication prompts are different from clinical medication advice; medicine questions should go to a pharmacist, GP or prescribing clinician.',
  ],
  Companionship: [
    'Companionship can support routine, confidence, conversation and connection with local life.',
    'A useful plan includes interests, preferred conversation topics, community links, mobility limits and family boundaries.',
    'If loneliness is linked to depression, self-neglect or safety concerns, involve a GP, adult social care or an appropriate support service.',
  ],
  'Live-in & Night Care': [
    'Clarify whether the arrangement is live-in care, sleeping-night support or waking-night support because expectations differ.',
    'Ask about breaks, accommodation for the carer, backup cover, emergency processes and supervision.',
    'For complex clinical needs, ask who is clinically responsible and whether specialist nursing or NHS input is required.',
  ],
  'Wellbeing at Home': [
    'Good home care can support everyday routines such as shopping lists, meal preparation, hydration reminders and safe encouragement.',
    'Care workers should follow the person’s care plan and avoid replacing advice from clinicians, dietitians or physiotherapists.',
    'Families should record allergies, dislikes, cultural preferences, safe swallowing guidance and professional instructions where relevant.',
  ],
  'Care Advice': [
    'Write down the person’s daily routine before contacting providers so the conversation is specific.',
    'Ask what the care plan will include, how it will be reviewed and who families can contact with concerns.',
    'Use official UK sources such as NHS, CQC, local authority and established charity guidance when checking claims.',
  ],
};

const categoryQuestions = {
  'Care Careers': [
    'What training, shadowing and supervision will I receive before working alone?',
    'How are travel time, rotas and visit changes communicated?',
    'Who do I contact if I am worried about a person, a family situation or my own safety?',
  ],
  'Choosing Care': [
    'Can I see your CQC information, complaints process and standard contract before making a decision?',
    'How do you reduce late visits, missed calls and rushed support?',
    'How will you introduce carers and keep family members informed?',
  ],
  'Funding & Planning': [
    'Should we request a care needs assessment before arranging private support?',
    'What charges are included, and what counts as an extra?',
    'How often should the care plan, budget or visit pattern be reviewed?',
  ],
  'Local Home Care': [
    'Do you already support people in this postcode or nearby community?',
    'How do you plan travel time, bad weather, parking and rural access?',
    'What backup cover is available if a regular carer cannot attend?',
  ],
  'Home Safety': [
    'Who holds emergency contacts, key-safe details and access instructions?',
    'What happens if the person does not answer the door?',
    'Which risks need professional input rather than a care-provider decision?',
  ],
  'Dementia Care': [
    'How will carers learn the person’s life story, preferences and calming routines?',
    'How do you handle changes in behaviour without giving medical advice?',
    'How are families updated if carers notice a change in eating, drinking, mood or routine?',
  ],
  'Family Support': [
    'What break does the unpaid carer need, and how often?',
    'Who is the main family contact for updates and decisions?',
    'What should trigger an earlier review of the care plan?',
  ],
  'Hospital to Home': [
    'What short-term support is already being arranged by hospital or community teams?',
    'What equipment, medicine information, food and access details need to be ready at home?',
    'Who should the family call if the care arrangement is not enough after discharge?',
  ],
  'Personal Care': [
    'What does the person want done independently, with help nearby, or with direct support?',
    'How will consent, privacy and preferred routines be recorded?',
    'Which medicine or clinical questions must be checked with a professional?',
  ],
  Companionship: [
    'What does a good week at home look like for this person?',
    'Which hobbies, community links or routines should be protected?',
    'How will the provider avoid making companionship feel forced or patronising?',
  ],
  'Live-in & Night Care': [
    'What support is expected during the day, evening and overnight?',
    'What breaks, sleeping arrangements and backup cover are in place?',
    'What happens if night-time needs become more frequent or complex?',
  ],
  'Wellbeing at Home': [
    'What foods, drinks, routines and activities does the person already enjoy?',
    'Are there any professional instructions that carers must follow?',
    'How should families be told if eating, drinking or movement routines change?',
  ],
  'Care Advice': [
    'What problem are we trying to solve first?',
    'What should remain the person’s choice and routine?',
    'What does the provider need to explain before care begins?',
  ],
};

const getOpening = (title, category, seed) => {
  const openings = openingByCategory[category] || openingByCategory['Care Advice'];
  const context = categoryIntro[category] || categoryIntro['Care Advice'];

  if (seed % 3 === 0) {
    return `${pick(openings, seed)} ${context}`;
  }

  if (seed % 3 === 1) {
    return `${pick(openings, seed)} This guide keeps the focus on everyday planning rather than diagnosis, treatment or legal advice.`;
  }

  return `${pick(openings, seed)} For ${title.toLowerCase()}, the useful question is what would make life at home safer, clearer or less pressured.`;
};

const getSafetyNote = (category) => {
  if (category === 'Care Careers') {
    return 'For employment terms, immigration, pay, contracts or safeguarding checks, applicants should rely on the official employer process and relevant professional or government guidance.';
  }

  if (category === 'Funding & Planning') {
    return 'This is general information, not financial or legal advice. Care funding can depend on personal circumstances, so use official guidance and get independent advice where needed.';
  }

  if (category === 'Home Safety') {
    return 'For urgent risks, safeguarding concerns or medical emergencies, contact the appropriate local authority team, NHS 111 or 999 as needed.';
  }

  if (category === 'Wellbeing at Home' || category === 'Dementia Care' || category === 'Personal Care') {
    return 'This is not medical advice. Diagnosis, symptoms, medication, diet, swallowing, mobility or treatment questions should be checked with the relevant NHS or regulated professional.';
  }

  return 'This article is general information. It should support a care conversation, not replace advice from adult social care, CQC, a GP, pharmacist or another regulated professional where that advice is needed.';
};

const boundaryHeadings = [
  'A note on boundaries',
  'Where to get specialist advice',
  'Keep this in the right lane',
  'When to pause and ask a professional',
];

const createBody = ({ title, category, cta, seed }) => {
  const flow = bodyFlows[category] || bodyFlows['Care Advice'];
  const practicalPoints = categoryPracticalPoints[category] || categoryPracticalPoints['Care Advice'];
  const questions = categoryQuestions[category] || categoryQuestions['Care Advice'];
  const firstHeading = pick(flow.firstHeadings, seed);
  const questionHeading = pick(flow.questionHeadings, seed + 1);
  const closingHeading = pick(flow.closingHeadings, seed + 2);
  const boundaryHeading = pick(boundaryHeadings, seed + 3);
  const ctaText = `If you are preparing for a care conversation, ${cta.toLowerCase()} can help turn a general worry into practical points to discuss with KCG or another provider.`;
  const framingText =
    'The most useful care conversations are specific. They describe the person’s routine, what has changed, who is involved and what would make home life feel more manageable.';
  const practicalText =
    'Use the points below as prompts, not a script. Some will matter immediately; others may only become useful when the care plan is reviewed.';
  const questionText =
    'These questions are designed to reveal how support will work in practice, especially when routines change or family members are not present.';

  if (seed % 3 === 0) {
    return [
      p(getOpening(title, category, seed)),
      p(framingText),
      h(firstHeading),
      list(practicalPoints),
      h(questionHeading),
      list(questions),
      h(closingHeading),
      p(flow.closing),
      p(ctaText),
      h(boundaryHeading),
      p(getSafetyNote(category)),
    ];
  }

  if (seed % 3 === 1) {
    return [
      p(getOpening(title, category, seed)),
      h(firstHeading),
      p(practicalText),
      list(practicalPoints),
      h(closingHeading),
      p(flow.closing),
      h(questionHeading),
      p(questionText),
      list(questions),
      h(boundaryHeading),
      p(getSafetyNote(category)),
      p(ctaText),
    ];
  }

  return [
    p(getOpening(title, category, seed)),
    h(firstHeading),
    p(framingText),
    list(practicalPoints),
    p(practicalText),
    h(questionHeading),
    list(questions),
    p(
      'If the answer to a question is vague, ask for an example of how the provider would handle that situation in a real visit.'
    ),
    h(boundaryHeading),
    p(getSafetyNote(category)),
    h(closingHeading),
    p(`${flow.closing} ${ctaText}`),
  ];
};

const pilotBlogPostOverrides = {
  "when-is-it-time-to-consider-home-care-a-uk-family-checklist": {
    title: "When to Consider Home Care: A Practical UK Family Checklist",
    slug: "when-to-consider-home-care",
    excerpt: "A practical checklist for families who are starting to notice missed meals, harder mornings, medication worries, falls concerns, loneliness or carer strain, and need a calmer way to decide what to ask next.",
    category: "Starting Care",
    seoTitle: "When to Consider Home Care: A Practical UK Family Checklist",
    seoDescription: "Not sure whether a parent needs help at home? Use this UK checklist to note daily changes, decide what to ask next, and prepare for a care conversation.",
    image: "/images/blog/generated/when-to-consider-home-care.svg",
    imageAlt: "A family kitchen table with a checklist, cup of tea, calendar and house key for deciding when home care may help.",
    body: markdownToBlocks(`Home care may be worth exploring when ordinary days at home are getting harder. That might mean meals are being missed, washing or dressing takes much longer, medication prompts are being forgotten, the house is slipping, or family carers are starting to feel stretched.

One difficult morning does not automatically mean someone needs a care package. A pattern is different. If the same worries keep coming up over a few weeks, write them down before you phone anyone. Clear notes help a GP, adult social care team, family member or care provider understand what is actually happening.

## What home care can and cannot do

Home care, sometimes called care at home or domiciliary care, usually means a paid carer visits someone in their own home. NHS and Age UK guidance describe support that can include help with everyday tasks and personal care, depending on what the person needs and what has been agreed.

In real life, that might look like help getting up in the morning, preparing a simple meal, prompting a routine, supporting washing and dressing, or checking someone has what they need before evening.

It is not the answer to every worry.

A home-care provider does not diagnose health changes, decide council eligibility, replace emergency help, give legal or financial advice, or take over decisions that belong with clinicians, councils or the person themselves. Good care starts by being clear about those boundaries.

## The changes to write down before contacting anyone

Use this list to collect examples. You are not trying to build a case against your parent or relative. You are trying to make the conversation specific.

### Daily living

Notice what is happening around meals, drinks, shopping, laundry, housework and the shape of the day.

Useful examples include:
- unopened food in the fridge;
- changes in weight or appetite that you want to raise with a GP or clinician;
- the same clothes being worn for several days;
- bins, washing or post building up;
- the person staying in bed much longer than usual;
- missed appointments because the morning routine has become too much.

Write down what changed, not just how it made you feel. “Dad has had toast for tea four nights this week” is more useful than “Dad is not coping”.

### Personal care

Personal care is often the point where families feel awkward. It can involve washing, dressing, continence support, shaving, hair care or feeling confident using the bathroom.

You might notice:
- someone avoiding the bath or shower;
- clothes not being changed as often;
- embarrassment about asking family for help;
- more washing, bedding or bathroom accidents;
- a morning routine that now takes two hours and leaves the person exhausted.

Try to keep the person’s dignity at the centre. If they are able and willing to talk, ask what feels hardest and what kind of help would feel least intrusive.

### Safety worries

Some families start thinking about care after a fright: a fall, a pan left on, a door left unlocked, or a parent stuck without their phone.

Write down the facts:
- what happened;
- when it happened;
- whether anyone was injured or frightened;
- whether it has happened before;
- who was told afterwards.

Do not use a blog checklist to decide whether a falls risk, confusion, injury or medical issue is serious. If someone may be seriously ill, injured, at immediate risk, or there is a risk to life, call 999. If urgent medical help is needed but it is not life-threatening, use NHS 111 online or call 111. For ongoing health changes, contact the person’s GP or relevant NHS service.

### Medication concerns

Families often notice medicines left in a dosette box, repeat prescriptions not collected, or uncertainty about whether tablets have been taken.

Home care may include agreed support around routines or prompts, but medication questions must stay with the right professional. If you are worried about missed, mixed-up or changed medicines, speak to a pharmacist, GP or the prescribing clinician. Do not stop, start or change medication because of an article online.

For your notes, record:
- what you found;
- whether this has happened before;
- whether the person understands the concern;
- which professional you have contacted or plan to contact.

### Social contact and mood

Sometimes the first sign is not a practical task. It is the person withdrawing.

A parent who used to go to the shop now waits for someone else to call in. A neighbour says the curtains stay closed. A weekly club has quietly stopped. Phone calls become shorter. The person says, “I just can’t be bothered,” or “I don’t want to be a nuisance.”

Home care can sometimes support routine and companionship, but changes in mood, distress, confusion or loss of confidence may need a GP, NHS or community support conversation too. Avoid diagnosing the reason yourself.

### Family-carer strain

The person needing support is not the only one to think about.

Home care may be worth discussing when family care has become difficult to sustain. That might mean:
- you are leaving work early most weeks;
- siblings are arguing because one person is doing nearly everything;
- you are sleeping badly because you are waiting for a phone call;
- visits have become rushed and tense;
- resentment is creeping in, even though you love the person;
- you cannot go away for a night without worrying.

This is not failure. It is useful information. Family carers can also ask the local council about a carer’s assessment, which looks at how caring affects them and what support may help.

## Home care readiness notes

Before you phone the council, GP, KCG or another provider, write down a few examples under these headings.

- What changed?
- When did it happen?
- How often is it happening?
- What has the person said about it?
- What help is already in place?
- What feels urgent?
- What can be planned?
- Who else needs to be involved in the conversation?

If you only have ten minutes, start with three examples from the last two weeks. That is often enough to make a first call more useful.

## What to do with the checklist

Start with the person, if the conversation can be had safely and respectfully. Many older people worry that asking for help means losing control. A practical conversation may feel better than a dramatic one.

You might say:

“I’ve noticed mornings have felt harder recently. Would it help if we wrote down what is tricky and looked at what support might make it easier?”

If the person wants a family member, friend or advocate involved, bring them in. If relatives disagree, use the notes rather than arguing from memory. Specific examples make it easier to separate facts from fear.

Then decide which route fits the concern:

- For health symptoms, medication worries, pain, falls, confusion or distress, contact the GP, pharmacist, NHS 111 or 999 as appropriate.
- For help with daily life that may need council support, ask the local council for a care needs assessment. GOV.UK also has a needs-assessment finder.
- For private home care, speak to providers about what support they can and cannot offer.
- For family-carer pressure, ask the council about a carer’s assessment.
- For safeguarding concerns, contact the local council’s adult safeguarding route, or call 999 if someone is in immediate danger.

## If the person lives in KCG’s service area

If the person lives in North Tyneside, Newcastle, Gateshead, Northumberland or the Tyne Valley, check KCG’s service area before requesting a care conversation. Coverage can depend on the exact address and the support needed.

Bring your notes to the first call. “Mum is struggling” is understandable, but it is hard to plan from. “Mum has missed lunch three times this week, is nervous getting into the shower, and my brother and I are covering every evening” gives a clearer starting point.

You can also read about the types of support at home KCG discusses with families, then request a care conversation if the person is in an area KCG may cover.

## A simple next step

Write down three examples from the last two weeks. Then decide who the first call belongs with: the person, another family member, the GP or pharmacist, the council, or a care provider.

That small piece of preparation can turn a vague worry into a clearer conversation.

If you are starting to write this list for someone in KCG’s service area, request a care conversation and bring your notes to the call: /request-care`),
    sources: [
      {
          "title": "NHS, Help at home from a paid carer",
          "url": "https://www.nhs.uk/social-care-and-support/care-services-equipment-and-care-homes/homecare/"
      },
      {
          "title": "NHS, Getting a care needs assessment",
          "url": "https://www.nhs.uk/social-care-and-support/help-from-social-services-and-charities/getting-a-needs-assessment/"
      },
      {
          "title": "Age UK, Home help and care for older people",
          "url": "https://www.ageuk.org.uk/information-advice/care/arranging-care/homecare/"
      },
      {
          "title": "CQC, What can you expect from a good home-care agency?",
          "url": "https://www.cqc.org.uk/care-services/what-expect-good-care-service/what-can-you-expect-good-home-care-agency"
      },
      {
          "title": "GOV.UK, Apply for a needs assessment by social services",
          "url": "https://www.gov.uk/apply-needs-assessment-social-services"
      },
      {
          "title": "NHS, When to call 999",
          "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-call-999/"
      },
      {
          "title": "NHS, When to use NHS 111 online or call 111",
          "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-use-111/"
      },
      {
          "title": "NHS, Carer’s assessments",
          "url": "https://www.nhs.uk/social-care-and-support/support-and-benefits-for-carers/carer-assessments/"
      },
      {
          "title": "GOV.UK, Report abuse of an older person",
          "url": "https://www.gov.uk/report-abuse-of-older-person"
      }
  ],
    cta: "If you are starting to write this list for someone in KCG’s service area, request a care conversation and bring your notes to the call: /request-care",
    safetyNote: "This article is general information about care at home, not medical, medication, legal, financial or safeguarding advice. This article cannot decide whether something is abuse or neglect. If someone may be seriously ill, injured, at immediate risk, or there is a risk to life, call 999. If urgent medical help is needed but it is not life-threatening, use NHS 111 online or call 111. For medication questions, speak to a pharmacist, GP or prescribing clinician. Care needs assessments, financial assessments and eligibility decisions are handled by the local council.",
  },
  "north-tyneside-home-care-how-families-can-compare-options": {
    title: "Home Care in North Tyneside: How Families Can Compare Options",
    slug: "north-tyneside-home-care-compare-options",
    excerpt: "A practical local guide for North Tyneside families comparing home care, including council assessment routes, CQC checks, provider questions, access planning and what to ask before deciding.",
    category: "Local Home Care",
    seoTitle: "Home Care in North Tyneside: How Families Can Compare Options",
    seoDescription: "Comparing home care in North Tyneside? Check council routes, CQC information, provider questions, visit planning and KCG’s local service area.",
    image: "/images/blog/generated/north-tyneside-home-care-compare-options.svg",
    imageAlt: "A North East coastal map, home marker, checklist and phone for comparing home care options in North Tyneside.",
    body: markdownToBlocks(`If you are comparing home care in North Tyneside, check three things before you choose: what support the person needs, which council or official route may apply, and what each provider can safely and reliably offer at that address.

Do not rely on one friendly phone call or a polished website. Compare written notes. Ask the same questions of each provider. Keep council assessment, CQC checks and provider conversations separate in your head, because they answer different questions.

## What home care can mean in North Tyneside

Home care, care at home and domiciliary care are often used to mean similar things: paid support in someone’s own home. NHS guidance describes help at home from a paid carer as support that may include everyday tasks and personal care.

For a North Tyneside family, the practical question is usually less tidy than the definition.

It might be a parent in North Shields who is fine once the day starts but cannot manage breakfast and washing. It might be someone in Whitley Bay whose daughter lives out of the area and needs reliable updates. It might be a couple in Wallsend where one person is quietly doing all the caring and getting tired.

The right support depends on the person, the address, the routine and the provider’s scope. No article can tell you which provider to choose, but a good comparison process can stop you being pushed into a decision before the details are clear.

## Step 1: write down the support needed

Start with the person’s ordinary week.

Write down:
- morning and evening routines;
- washing, dressing or continence support that may be needed;
- meals, drinks, shopping and household tasks;
- medication prompts or concerns that need a pharmacist, GP or clinician’s view;
- companionship, confidence and social contact;
- access arrangements, such as keys, entry systems, flats, parking or pets;
- who in the family should receive updates;
- what already works well and should not be disrupted.

This helps you avoid vague enquiries. “We need someone to pop in” could mean almost anything. “Mum needs help with breakfast, washing, clean clothes and a short update to my brother after each visit” gives a provider something practical to respond to.

If you are not sure whether care is needed yet, use a family checklist first and record what has changed over the last fortnight.

## Step 2: check council assessment routes separately

If the person may need support with daily life, North Tyneside Council’s adult care and support pages are the local place to check for council information. The council also publishes information about social care assessments.

A council assessment route is not the same as asking a private provider for a quote. The council looks at care and support needs and may then consider eligibility, planning and financial assessment routes. A provider can explain what it offers privately, but it cannot decide council eligibility or funding.

Keep these questions separate:

- Do we need to ask North Tyneside Council about a care needs assessment?
- Is a family carer under strain and in need of their own support route?
- Are we comparing private providers while the council route is being explored?
- Has anyone written down what support is needed day to day?

If the person lives near a council boundary or relatives are arranging care from elsewhere, check the correct local authority for the person’s home address. GOV.UK’s needs-assessment finder can help with that.

## Step 3: check CQC and provider information

CQC provides a way to search for home-care agencies and read published information about regulated services. CQC also publishes guidance on what people can expect from a good home-care agency, including respect, involvement, safe care and complaints.

Use CQC as one part of your comparison, not the whole decision.

When you speak to a provider, ask:
- where you can find their CQC information;
- what services are being discussed for this person;
- what the care plan would include;
- how visits are recorded;
- how concerns or complaints are raised;
- what happens if needs change.

Do not ask only, “Are you good?” Ask for the practical evidence: how the provider plans care, communicates, reviews support and responds when something goes wrong.

## Step 4: ask North Tyneside-specific provider questions

Local care is not just about whether the office is nearby. It is about whether the provider can plan visits around real homes and real routes.

Use these questions when comparing providers in places such as North Shields, Tynemouth, Whitley Bay, Cullercoats, Wallsend, Longbenton, Monkseaton or Shiremoor.

### Coverage

- Do you cover this exact postcode?
- Are there any parts of North Tyneside where availability is more limited?
- What would make a visit pattern easier or harder to arrange?

### Visit timing and local travel

- What visit times are realistic for this address and routine?
- How do you allow for local travel, parking, school traffic, coastal traffic or bad weather?
- How will you tell us if a carer is delayed?

### Continuity

- How do you introduce carers to the person?
- How many different carers might the person usually meet?
- What happens when the regular carer is off sick or on leave?

### Access to the home

- What access information do you need before care starts?
- How should key safe details, entry codes, pets, flats or parking restrictions be recorded?
- What happens if the person does not answer the door?

### Family updates

- Who is the main family contact?
- How are visit notes shared, where appropriate?
- What would trigger a phone call rather than a routine note?

### Changes and concerns

- How can visits be increased, reduced or paused?
- What happens if needs change quickly?
- What is your complaints process?
- Who responds if a visit feels rushed, late or missed?

A provider does not need a perfect script. You are looking for answers you can understand, write down and compare later.

## North Tyneside home-care comparison sheet

Use this for each provider, including KCG if you speak to the team.

Person’s support needs:
- What help is needed in the morning?
- What help is needed later in the day?
- What does the person want to keep doing independently?
- What worries the family most?

Council/adult social care information checked?
- North Tyneside Council adult care and support page checked: yes/no
- Social care assessment information checked: yes/no
- Carer support route considered if a family carer is under strain: yes/no
- Questions still for the council:

Provider/CQC information checked?
- Provider name:
- CQC page checked: yes/no
- Services discussed:
- Care plan and review process explained: yes/no
- Complaints process explained: yes/no

Local visit practicalities:
- Exact postcode covered: yes/no/to confirm
- Access instructions noted:
- Parking or entry issues:
- Pets or household details:
- Family update route:
- Backup plan if a carer is delayed or unavailable:

Questions still unanswered:
- What needs written confirmation?
- What needs a second call?
- What needs council, GP, pharmacist or independent advice?

## How to compare answers without being rushed

After two or three calls, details can blur. Put answers side by side.

Watch for vague replies. For example, “We’re very flexible” is less useful than “We can discuss mornings, but we need to check availability for that postcode and visit length.”

Be careful with any provider that avoids questions about CQC information, complaints, visit scope or what happens when care needs change. That does not automatically mean the provider is unsafe, but it does mean you should ask again and get the answer in writing before agreeing.

Also notice how the person receiving care feels. A family may like the efficiency of an answer, while the person at home may worry about strangers, privacy or losing control. Those concerns matter and should be part of the care plan conversation.

## Where KCG fits

If you are considering KCG, check KCG’s North Tyneside service area first. Then request a care conversation with your notes ready.

Ask KCG the same questions you ask any other provider. KCG cannot decide council eligibility or funding. A first conversation should help you understand whether the support being discussed is within scope, whether the area can be considered, and what the next step would be.

Check whether KCG covers your part of North Tyneside, then request a care conversation with your comparison questions ready: /where-we-operate#north-tyneside and /request-care`),
    sources: [
      {
          "title": "North Tyneside Council, Adult care and support",
          "url": "https://www.northtyneside.gov.uk/help-and-support-north-tyneside/adult-care-and-support"
      },
      {
          "title": "North Tyneside Council, Social care assessment page",
          "url": "https://www.northtyneside.gov.uk/help-and-support-north-tyneside/adult-care-and-support/step-by-step/what-expect-our-services/social"
      },
      {
          "title": "NHS, Help at home from a paid carer",
          "url": "https://www.nhs.uk/social-care-and-support/care-services-equipment-and-care-homes/homecare/"
      },
      {
          "title": "CQC, Find homecare agencies",
          "url": "https://www.cqc.org.uk/care-services/find-homecare-agencies"
      },
      {
          "title": "CQC, What can you expect from a good home-care agency?",
          "url": "https://www.cqc.org.uk/care-services/what-expect-good-care-service/what-can-you-expect-good-home-care-agency"
      },
      {
          "title": "GOV.UK, Apply for a needs assessment by social services",
          "url": "https://www.gov.uk/apply-needs-assessment-social-services"
      },
      {
          "title": "North Tyneside Council, Carers assessments",
          "url": "https://www.northtyneside.gov.uk/help-and-support-north-tyneside/adult-care-and-support/caring-someone/carers-assessments"
      },
      {
          "title": "NHS, When to call 999",
          "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-call-999/"
      },
      {
          "title": "NHS, When to use NHS 111 online or call 111",
          "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-use-111/"
      }
  ],
    cta: "Check whether KCG covers your part of North Tyneside, then request a care conversation with your comparison questions ready: /where-we-operate#north-tyneside and /request-care",
    safetyNote: "This article is general information, not council, legal, financial, medical or safeguarding advice. North Tyneside Council handles local council assessment routes and funding decisions. CQC publishes provider information but does not choose a provider for you. For urgent medical help, use NHS 111 or 999 as appropriate. For safeguarding concerns, contact the local council adult safeguarding route, or 999 if someone is in immediate danger.",
  },
  "20-questions-to-ask-a-home-care-agency-before-you-sign": {
    title: "20 Questions to Ask a Home Care Agency Before You Agree to Care",
    slug: "questions-to-ask-home-care-agency",
    excerpt: "Use these 20 questions on calls with any home-care agency, including KCG, so you can compare care planning, visit timing, continuity, medication boundaries, costs, complaints and family updates without relying on vague promises.",
    category: "Choosing Care",
    seoTitle: "20 Questions to Ask a Home Care Agency Before You Agree to Care",
    seoDescription: "Use these 20 questions before agreeing to home care. Check care plans, timing, continuity, medication boundaries, costs and complaints.",
    image: "/images/blog/generated/questions-to-ask-home-care-agency.svg",
    imageAlt: "A home-care question checklist with speech bubbles, pen and folder for comparing agency answers before agreeing to care.",
    body: markdownToBlocks(`Ask direct questions before you agree to home care. A good provider should be able to explain what support is being offered, what is outside scope, how visits are planned, how concerns are handled, and what will be put in writing.

Use the same questions with each agency and take notes during the call. If 20 questions feels like too much, mark the five that matter most before you phone. If something matters to the person receiving care, ask for it to be written into the care plan or agreement where appropriate.

## How to use these questions

Do not treat this as an interview where you are trying to catch someone out. Treat it as a way to understand how care would work in a real home.

Before the call, write down:
- the person’s address or general area;
- the routine that is becoming difficult;
- who should be involved in decisions;
- any health, medication or safeguarding questions that need to stay with professionals;
- what needs written confirmation before you agree.

If the person receiving care wants to join the conversation, include them. If they do not want to be on the phone, ask how they would like their preferences shared.

## Questions about assessment and care planning

1. How do you assess what support is needed before care starts?

Listen for how the provider learns about the person, their routine, their home, their risks, their preferences and what family members are worried about. It should also make clear what happens if the provider thinks another professional needs to be involved.

2. How will the care plan be written, shared and reviewed?

Ask who writes it, who can see it, how the person is involved, and how changes are made. CQC’s person-centred care regulation is a useful source to check because care should reflect the person’s needs and preferences.

3. How do you include the person’s routines, preferences and communication needs?

This is where small details matter: how someone likes to be addressed, whether they prefer a quiet morning, what makes personal care less embarrassing, which family member should be contacted, and what the person still wants to do independently.

## Questions about visits, timing and continuity

4. What visit lengths and times are being discussed, and what can realistically be done in that time?

The provider should not pretend every task can fit into any slot. Ask what can be done safely and respectfully in the proposed visit length, especially around mornings, meals and personal care.

5. How do you plan continuity of carers?

Continuity matters because people often feel more comfortable with familiar carers. Ask how introductions work, what usual staffing patterns look like, and what happens when the regular carer is unavailable. Be wary of promises the provider cannot realistically guarantee.

6. What happens if a carer is delayed, off sick or cannot attend?

Ask who contacts the person or family, when they contact them, and what backup arrangements exist. This question is especially important when the person lives alone or relies on support to get up, eat or take part in the day.

## Questions about personal care, dignity and boundaries

7. How do you support personal care respectfully and privately?

The answer should include dignity, consent, privacy and the person’s choices. Ask how preferences are recorded and how carers respond if the person feels embarrassed or anxious.

8. What tasks are within scope, and what tasks are not?

Families need plain answers here. Some tasks belong with a care provider, some with the family, and some with clinicians, pharmacists, occupational therapists, the council or emergency services. The boundary matters more than a confident-sounding yes.

9. How do you respond if the person refuses support on the day?

Refusal can happen for many reasons. Do not ask the agency to override the person. Ask how carers record the situation, what they try next, when family is contacted, and when a professional route may be needed.

## Questions about medication and health-related boundaries

10. What support can you provide around medicines, and what must stay with a pharmacist, GP or clinician?

This is a safety question. Do not ask a home-care agency for medication advice. Ask what support is within its policy and the care plan, and what questions must go back to a pharmacist, GP or prescribing clinician.

11. How are changes in health or wellbeing recorded and escalated?

Listen for what carers record, who reviews notes, who contacts family, and when the provider would advise contacting a GP, NHS 111, 999 or another professional.

## Questions about care workers, supervision and quality

12. How are care workers introduced to the person and their care plan?

Ask whether carers read the plan before visiting, how introductions are handled, and how personal preferences are passed on. This is often where families learn whether the provider has thought beyond rota cover.

13. What supervision or checks help you know care is being delivered as planned?

The provider should be able to explain how it checks care quality, supports staff and picks up concerns. Do not accept vague reassurance alone. Ask for the process.

14. How can we check your CQC information?

CQC has a service search for regulated care providers. A provider should be able to tell you how to find its information and should be comfortable with you reading it before deciding.

## Questions about family updates and records

15. How are visit notes recorded and shared where appropriate?

Ask what is recorded after a visit, who can access notes, and how privacy is protected. If family members live away, agree who receives updates so the provider is not pulled in five directions.

16. Who should family members contact with updates or concerns?

There should be a clear contact route. Ask who to call about routine changes, who to contact if a visit feels wrong, and how quickly the provider usually responds to non-urgent messages. Avoid assuming the care worker on the doorstep is the right person for every decision.

## Questions about costs, agreements and changes

17. What is included in the quoted care arrangement, and what could change the cost?

This is not about haggling in a worried week. It is about knowing what you are agreeing to before care starts. Ask for written information about visit length, frequency, charges, cancellations, weekends, bank holidays and anything that could change the cost. For financial or contract advice, use independent advice where needed.

18. How can care be changed, paused or ended?

Needs change. Family availability changes. Hospital stays happen. Ask what notice is needed, what happens if support needs increase, and how reviews are arranged.

## Questions about complaints and concerns

19. What is your complaints process?

A provider should be able to explain how to raise a concern, who responds, and how complaints are recorded and acted on. CQC Regulation 16 covers receiving and acting on complaints, and CQC also explains how it uses information about services.

20. What should we do if a visit is late, rushed or missed?

Ask for the practical route: who to contact, what will be checked, how the person will be kept safe, and how the provider learns from the issue. This question is uncomfortable, but it is better asked before care starts.

## Provider call notes

Use this for each agency so you can compare answers later.

- Provider name:
- Date of call:
- Who attended the call:
- Person’s preferred routine discussed: yes/no
- CQC page checked: yes/no
- Questions answered clearly:
- Questions needing written follow-up:
- Any claims that need checking:
- Medication or health questions to take to a pharmacist, GP or clinician:
- Cost or agreement questions needing independent advice:
- Next step agreed: yes/no

## Extra questions for North East families

These are not part of the numbered 20, but they are useful if the person lives in North Tyneside, Newcastle, Gateshead, Northumberland or the Tyne Valley.

Ask:
- Which parts of the area do you cover, and do you cover this exact postcode?
- How do you plan travel time, weather, parking and access across local routes?
- What happens if staff absence, traffic or changing needs affect visits?
- If a council assessment or direct payments are involved, which questions need to stay with the council?
- How will you keep relatives informed if they live outside the area?

For KCG, check the service area before requesting a care conversation.

## Use the questions with any provider

The point of these questions is not to find a provider with a perfect script. It is to find one that can explain the work clearly, admit boundaries and put important details in writing.

Use the same list with KCG or any other home-care agency. If an answer is vague, ask for an example. If the answer affects safety, cost, medication, legal responsibilities or council support, check the right source before agreeing.

Use these questions when you speak to KCG or any other provider. If you want to compare answers for care in KCG’s service area, request a care conversation: /request-care. You can also check the service area first: /where-we-operate`),
    sources: [
      {
          "title": "CQC, What can you expect from a good home-care agency?",
          "url": "https://www.cqc.org.uk/care-services/what-expect-good-care-service/what-can-you-expect-good-home-care-agency"
      },
      {
          "title": "CQC, Find homecare agencies",
          "url": "https://www.cqc.org.uk/care-services/find-homecare-agencies"
      },
      {
          "title": "CQC, Regulation 9: Person-centred care",
          "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-9"
      },
      {
          "title": "CQC, Regulation 12: Safe care and treatment",
          "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-12"
      },
      {
          "title": "CQC, Regulation 16: Receiving and acting on complaints",
          "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-16"
      },
      {
          "title": "Homecare Association, Choosing care at home",
          "url": "https://www.homecareassociation.org.uk/find-care/choosing-care-at-home.html"
      },
      {
          "title": "NHS, Help at home from a paid carer",
          "url": "https://www.nhs.uk/social-care-and-support/care-services-equipment-and-care-homes/homecare/"
      },
      {
          "title": "CQC, Complain about a service or provider",
          "url": "https://www.cqc.org.uk/contact-us/how-complain/complain-about-service-or-provider"
      },
      {
          "title": "NHS, When to call 999",
          "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-call-999/"
      },
      {
          "title": "NHS, When to use NHS 111 online or call 111",
          "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-use-111/"
      },
      {
          "title": "GOV.UK, Apply for direct payments",
          "url": "https://www.gov.uk/apply-direct-payments"
      },
      {
          "title": "Citizens Advice",
          "url": "https://www.citizensadvice.org.uk/"
      },
      {
          "title": "Age UK, Money and legal",
          "url": "https://www.ageuk.org.uk/information-advice/money-legal/"
      },
      {
          "title": "Age UK, Paying for care at home",
          "url": "https://www.ageuk.org.uk/information-advice/care/paying-for-care/paying-for-homecare/"
      }
  ],
    cta: "Use these questions when you speak to KCG or any other provider. If you want to compare answers for care in KCG’s service area, request a care conversation: /request-care. You can also check the service area first: /where-we-operate",
    safetyNote: "This article is general information, not medical, medication, legal or financial advice. Medication questions should go to a pharmacist, GP or prescribing clinician. Cost, agreement, benefits or legal questions may need Citizens Advice or independent legal or financial advice. If someone may be seriously ill, injured, at immediate risk, or there is a risk to life, call 999. If urgent medical help is needed but it is not life-threatening, use NHS 111 online or call 111. Council assessment, funding and direct-payment decisions sit with the local council.",
  },
  "how-to-start-a-care-needs-assessment-in-england": {
    title: "How to Start a Care Needs Assessment in England",
    slug: "start-care-needs-assessment-england",
    excerpt: "A practical guide to starting a care needs assessment in England, including what to write down before contacting the council and where private home care fits.",
    category: "Funding & Planning",
    seoTitle: "How to Start a Care Needs Assessment in England | KCG",
    seoDescription: "Learn how to request a care needs assessment in England, what to prepare, how it differs from a financial assessment, and what families can do while waiting.",
    image: "/images/blog/generated/start-care-needs-assessment-england.svg",
    imageAlt: "A kitchen table with a notebook, council letter, phone and tea mug for preparing care needs assessment notes.",
    body: markdownToBlocks("A care needs assessment is the usual council route for looking at whether an adult needs support with daily life. If you are worried about washing, meals, getting around safely, family-carer strain or managing at home, the local council is the place to contact about an assessment.\n\nYou do not need perfect wording before you ask. What helps is a clear record of what has changed, what support is already in place, and what daily tasks have become difficult. The council handles assessment and eligibility decisions. A private home-care provider can talk about care options, but it cannot decide council support or funding.\n\n## What a care needs assessment is\n\nNHS and GOV.UK guidance explain that a needs assessment looks at the help someone may need with everyday living. It can cover things such as personal care, staying safe at home, preparing meals, getting out and about, maintaining relationships, and whether a family carer is under pressure.\n\nIt is not only for people who already receive care. You can ask for an assessment when you think support may be needed. A family member, friend or advocate may help with the request if the person agrees or needs support to communicate.\n\nThe important point is this: the assessment is about needs first. Money is a separate question.\n\n## Needs assessment and financial assessment are different\n\nFamilies often mix these two up because they happen in the same overall social-care system.\n\nA care needs assessment looks at what support the person may need and whether the council considers those needs eligible under its responsibilities. A financial assessment, sometimes called a means test, looks at whether the person may need to contribute towards care costs and how much.\n\nDo not assume that asking for a care needs assessment means care will be free, funded or arranged in a particular way. Do not assume the opposite either. Ask the council to explain the route, then keep notes of what has been said.\n\n## What to write down before contacting adult social care\n\nBefore you contact the council, collect practical examples. You are not trying to make the situation sound worse. You are trying to make it clear.\n\nWrite down:\n\n- what the person is finding difficult at home;\n- how often it happens;\n- when it started or became worse;\n- what help family, friends or neighbours already provide;\n- what the person wants to keep doing independently;\n- any falls, confusion, medication concerns or health changes that also need NHS or GP advice;\n- whether a family carer is struggling;\n- what feels urgent and what could be planned.\n\nUseful examples are specific. “Dad has missed lunch four times this week” is more helpful than “Dad is not coping”. “Mum is frightened of showering and now waits until I visit” is clearer than “Mum needs personal care”.\n\n## Which council should you contact?\n\nThe relevant council is normally the local authority for the person’s home address. GOV.UK has a needs-assessment finder if you are unsure.\n\nIf the person lives in KCG’s wider North East service area, check the correct local adult social care route. That might be Newcastle, North Tyneside, Gateshead or Northumberland, depending on the address. Council boundaries matter, especially if relatives live elsewhere or the person is near a boundary.\n\nPrivate care conversations can happen alongside council enquiries, but keep them separate. The council decides council assessment and eligibility questions. A provider can only explain what it may be able to offer privately, subject to assessment, availability, scope and location.\n\n## Questions to ask the council\n\nUse this list during the first call or online enquiry:\n\n- Is this the correct council for the person’s address?\n- How do we request a care needs assessment?\n- What information should we provide now?\n- Can a family member help with the request?\n- How will the person be involved?\n- When would a separate financial assessment be discussed?\n- What should we do if the situation changes before the assessment?\n- Which concerns should go to the GP, NHS 111 or emergency services instead?\n\nKeep a note of the date, who you spoke to and what next step was explained.\n\n## Where private home care fits\n\nSome families contact private providers while waiting for, preparing for or separately from a council assessment. That can be sensible if you keep the roles clear.\n\nA provider may discuss practical support such as morning routines, meals, companionship, personal care or family updates. It should also explain what is outside scope and what needs to stay with the council, GP, pharmacist, NHS or another professional.\n\nWrite down three examples from the last two weeks, then check the correct council route for the person’s address. If you are also considering private home care, bring the same notes to the call. They make the conversation more useful. They do not replace the council assessment."),
    sources: [
      {"title": "NHS, Getting a care needs assessment", "url": "https://www.nhs.uk/social-care-and-support/help-from-social-services-and-charities/getting-a-needs-assessment/"},
      {"title": "GOV.UK, Apply for a needs assessment by social services", "url": "https://www.gov.uk/apply-needs-assessment-social-services"},
      {"title": "Age UK, The care needs assessment explained", "url": "https://www.ageuk.org.uk/information-advice/care/arranging-care/care-needs-assessment/"},
      {"title": "GOV.UK, Care and support statutory guidance", "url": "https://www.gov.uk/government/publications/care-act-statutory-guidance/care-and-support-statutory-guidance"},
      {"title": "NHS, When to use NHS 111 online or call 111", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-use-111/"},
      {"title": "NHS, When to call 999", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-call-999/"}
    ],
    cta: "If you are also considering private home care while preparing for a council assessment, request a care conversation and keep council decisions separate: /request-care",
    safetyNote: "This article is general information about adult social care in England, not legal, financial, medical or council advice. Local councils handle care needs assessments, eligibility decisions, financial assessments and council-funded support. For urgent medical help, use NHS 111 or 999 as appropriate.",
  },
  "cqc-ratings-for-home-care-how-to-read-them-without-panicking": {
    title: "CQC Ratings for Home Care: How to Read Reports Without Panicking",
    slug: "cqc-ratings-home-care",
    excerpt: "A calm guide to reading CQC home-care information, understanding what ratings and reports can tell you, and turning concerns into practical provider questions.",
    category: "Choosing Care",
    seoTitle: "CQC Ratings for Home Care: How to Read Reports Without Panicking | KCG",
    seoDescription: "Understand CQC ratings for home care, what reports can and cannot tell families, and which questions to ask a care provider after reading them.",
    image: "/images/blog/generated/cqc-ratings-home-care.svg",
    imageAlt: "A care report, magnifying glass and checklist on a desk for calmly comparing home-care information.",
    body: markdownToBlocks("CQC information is useful when you are comparing home-care agencies, but it should not be the only thing you use. A rating or report can help you ask better questions. It cannot tell you exactly how care will feel in one person’s home next Tuesday morning.\n\nIf you have found a CQC page and feel worried, slow down. Read the report, note the dates, ask the provider clear questions, and look at how the proposed care plan would work for the person in front of you.\n\n## What CQC does\n\nThe Care Quality Commission, usually called CQC, regulates health and social care services in England. Its website lets people search for care services and published information about providers, including home-care agencies.\n\nCQC information may include ratings, inspection reports, registration details and updates. The language can feel formal, but the aim for families is simple: use it to understand what has been checked, what was found, and what you need to ask next.\n\nDo not use phrases such as “CQC-approved”. CQC regulates and inspects services; it does not choose a provider for your family.\n\n## Start with the basics\n\nWhen you find a provider’s CQC page, check:\n\n- the provider name and location;\n- whether it is the right service, not a similarly named branch;\n- the date of the latest report or update;\n- the rating shown, if one is available;\n- whether any areas were highlighted as concerns or improvements;\n- whether the provider has changed since the report was written.\n\nDates matter. A very old report may not reflect everything happening today. A recent concern may need a careful follow-up question. Either way, the report is a prompt for conversation, not the whole decision.\n\n## Read the report before reacting to the rating\n\nA rating is a shortcut. The report gives the detail.\n\nLook for what the report says about people’s experience, safe care, staffing, records, medicines, complaints, leadership and how the service responds when things need to improve. You do not need to become a regulator. You need to understand whether the issues mentioned are relevant to the care you are arranging.\n\nIf the report uses language that worries you, copy the exact phrase into your notes and ask the provider about it. Avoid turning a half-read sentence into a family panic.\n\n## What CQC can and cannot tell you\n\nCQC information can help you see whether a provider is registered, what published inspection information says, and what broad quality themes have been identified.\n\nIt cannot promise that a particular carer will suit your parent, that a morning visit will be available at your preferred time, that every visit will feel the same, or that the care plan will automatically fit the person’s routines.\n\nThat is why CQC should sit alongside provider questions, written care planning, family observations and the person’s own view.\n\n## Questions to ask after reading a CQC report\n\nUse these questions with any provider, including KCG if you are considering the team.\n\n- Where can we find your current CQC information?\n- Is this the correct CQC page for the service that would provide care?\n- What has changed since the latest report was published?\n- If the report mentioned an area for improvement, what was done afterwards?\n- How do you make sure care is person-centred in daily visits?\n- How are risks, medication boundaries and changes in health or wellbeing recorded?\n- How do people raise complaints or concerns?\n- How are visit notes reviewed?\n- How is the care plan updated when needs change?\n- What would you put in writing before care starts?\n\nA confident provider should not be offended by these questions. The answer does not need to be polished. It needs to be clear.\n\n## Watch the care plan, not only the rating\n\nA good care plan turns general promises into daily support. It should explain what the person needs, what they prefer, what carers should do, what is outside scope, who to contact, and when the plan should be reviewed.\n\nFor example, “personal care” is too broad on its own. The plan should make daily life clearer: how the person likes to be addressed, what help they want with washing or dressing, what they can do independently, what feels embarrassing, and what should happen if they refuse support on the day.\n\n## If a report raises concerns\n\nDo not ignore concerns, but do not guess either. Write down what the concern says, the date of the report, whether CQC says action was required or taken, what you want the provider to explain, and what you need confirmed in writing before deciding.\n\nIf the provider avoids the question, becomes defensive, or cannot explain how care is monitored and reviewed, that is useful information for your comparison.\n\n## Local provider checks\n\nIf the person lives in North Tyneside, Newcastle, Gateshead, Northumberland or the Tyne Valley, use CQC search alongside local practical checks. Ask whether the provider can consider the exact postcode, what visit times are realistic, how travel and access are planned, and how relatives will be updated.\n\nDo not assume that a provider with a nearby name covers every address. Check KCG’s service area before requesting a care conversation: /where-we-operate."),
    sources: [
      {"title": "CQC, Find homecare agencies", "url": "https://www.cqc.org.uk/care-services/find-homecare-agencies"},
      {"title": "CQC, Find care services", "url": "https://www.cqc.org.uk/care-services"},
      {"title": "CQC, Using the information we provide", "url": "https://www.cqc.org.uk/about-us/how-we-do-our-job/using-information-we-provide"},
      {"title": "CQC, What can you expect from a good home-care agency?", "url": "https://www.cqc.org.uk/care-services/what-expect-good-care-service/what-can-you-expect-good-home-care-agency"},
      {"title": "CQC, Regulation 9: Person-centred care", "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-9"},
      {"title": "CQC, Regulation 12: Safe care and treatment", "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-12"},
      {"title": "CQC, Regulation 16: Receiving and acting on complaints", "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-16"}
    ],
    cta: "Bring your CQC questions to a care conversation and ask how the provider turns quality expectations into daily visits: /request-care",
    safetyNote: "This article is general information about using CQC information when comparing home-care providers. It does not state or imply KCG’s CQC rating or registration status. Always check the current CQC page for the exact service you are considering.",
  },
  "what-goes-into-a-good-care-and-support-plan": {
    title: "What Goes Into a Good Care and Support Plan?",
    slug: "care-and-support-plan-guide",
    excerpt: "A practical guide to what a care and support plan should make clear, from routines and preferences to visit tasks, contacts, risks, reviews and changes.",
    category: "Funding & Planning",
    seoTitle: "What Goes Into a Good Care and Support Plan? | KCG",
    seoDescription: "Learn what a good care and support plan can include, how council plans and provider care plans differ, and what families should write down before care starts.",
    image: "/images/blog/generated/care-and-support-plan-guide.svg",
    imageAlt: "A care plan folder, calendar, phone and home key arranged on a table for planning support at home.",
    body: markdownToBlocks("A good care and support plan brings care out of people’s heads and into a clear, usable record. It should help the person receiving care, family members and care workers understand what support is needed, what matters to the person, and what should happen if things change.\n\nThe plan does not need to be complicated. It does need to be specific enough for daily care.\n\n## Council plans and provider plans are not the same thing\n\nNHS guidance explains that a care and support plan may follow a council care needs assessment. That kind of plan is linked to the council’s assessment, eligible needs and agreed support.\n\nA private home-care provider may also create a care plan for the support it provides. That plan should be practical and person-centred, but it does not replace the council’s responsibilities. A provider cannot decide council eligibility, funding or financial assessment outcomes.\n\nFamilies should keep both ideas clear. Council care and support planning belongs with the council. Provider care planning belongs with the provider and the person receiving care.\n\n## Start with the person, not the task list\n\nA task list matters, but it is not enough.\n\n“Help with breakfast” tells a carer what to do. It does not explain that the person likes tea before food, feels embarrassed if rushed, wants to choose their own clothes, and becomes anxious if family members talk over them.\n\nA good plan should record:\n\n- what the person can do independently;\n- what they want help with;\n- what they do not want help with unless necessary;\n- preferred routines;\n- communication needs;\n- cultural, faith or personal preferences where relevant;\n- what helps the person feel respected and in control.\n\nSmall details can make care feel human.\n\n## Care-plan contents checklist\n\nUse this as a preparation list before a first assessment, review or provider conversation.\n\nPersonal details and contacts:\n\n- preferred name;\n- main family or representative contact;\n- GP, pharmacy or relevant professional contacts where appropriate;\n- emergency contact route;\n- who should receive routine updates.\n\nDaily routines:\n\n- usual wake-up and bedtime routine;\n- washing, dressing and grooming preferences;\n- meals, drinks and food likes or dislikes;\n- mobility and confidence around the home;\n- social routines, hobbies or important appointments.\n\nSupport tasks:\n\n- what carers are expected to do during each visit;\n- what the person wants to keep doing themselves;\n- what family members still provide;\n- what is outside the provider’s role;\n- what should be recorded after each visit.\n\nHealth and medication boundaries:\n\n- known health concerns that professionals are already involved with;\n- medication support that has been agreed within the provider’s policy and care plan;\n- questions that must go to a pharmacist, GP or clinician;\n- what changes should be reported and to whom.\n\nHome and access:\n\n- key safe, entry or door-answering arrangements;\n- pets, alarms, parking, stairs or equipment;\n- rooms carers should or should not use;\n- household routines that matter.\n\n## Make the plan usable on a normal day\n\nA care plan should not sit in a folder that nobody understands. It should help with ordinary decisions.\n\nFor example:\n\n- If the person is tired, what support is still essential?\n- If they refuse a shower, what should the carer do next?\n- If they seem confused, who should be contacted?\n- If food is untouched for several visits, how is that recorded and escalated?\n- If family want to change visit times, who handles that request?\n\nGood planning reduces guesswork. It does not remove the need for judgement, kindness or professional boundaries.\n\n## What families should bring to the conversation\n\nFamilies often hold important information in texts, memory and notebooks. Before a care-planning conversation, gather it into one place.\n\nWrite down a normal weekday and weekend routine, what has changed recently, what the person finds embarrassing or important, which tasks family members already do, what family members are worried about, and what the person wants care to help them keep doing.\n\nIf relatives disagree, use facts rather than labels. “Mum has left the oven on twice this month” is more useful than “Mum is unsafe”. “Dad says he does not want help washing from family” is more useful than “Dad is difficult”.\n\n## When a care plan should be reviewed\n\nA care plan should change when daily life changes. Ask for a review if visits feel rushed or unclear, routines have changed, there are repeated refusals of support, new health or mobility concerns have appeared, family carers can no longer provide the same help, or the agreed tasks no longer match what is happening in the home.\n\nFor urgent medical concerns, use NHS routes. For council assessment or funding questions, contact the council. For private care-plan details, contact the provider.\n\nIf you are arranging support with KCG, bring notes about routines, preferences and concerns so the care plan starts from real daily life. Ask what can be included, what needs professional input, how reviews work, and how family updates are handled."),
    sources: [
      {"title": "NHS, Care and support plans", "url": "https://www.nhs.uk/social-care-and-support/help-from-social-services-and-charities/care-and-support-plans/"},
      {"title": "NHS, Getting a care needs assessment", "url": "https://www.nhs.uk/social-care-and-support/help-from-social-services-and-charities/getting-a-needs-assessment/"},
      {"title": "GOV.UK, Care and support statutory guidance", "url": "https://www.gov.uk/government/publications/care-act-statutory-guidance/care-and-support-statutory-guidance"},
      {"title": "CQC, Regulation 9: Person-centred care", "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-9"},
      {"title": "CQC, What can you expect from a good home-care agency?", "url": "https://www.cqc.org.uk/care-services/what-expect-good-care-service/what-can-you-expect-good-home-care-agency"},
      {"title": "NHS, When to use NHS 111 online or call 111", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-use-111/"},
      {"title": "NHS, When to call 999", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-call-999/"}
    ],
    cta: "If you are arranging support with KCG, bring notes about routines, preferences and concerns so the care plan starts from real daily life: /request-care",
    safetyNote: "This article is general information about care planning, not legal, financial, medical, medication or council advice. Council care planning, eligibility and funding decisions sit with the local council. Medication, health, falls, mental-capacity, safeguarding or urgent concerns should be taken to the appropriate professional or emergency route.",
  },
  "after-hospital-discharge-how-reablement-and-ongoing-home-care-differ": {
    title: "After Hospital Discharge: Reablement, Short-Term Support and Ongoing Home Care",
    slug: "hospital-discharge-reablement-home-care",
    excerpt: "A calm UK guide to the first week home after hospital discharge, how reablement may differ from ongoing home care, and what families should ask before arranging support.",
    category: "Hospital to Home",
    seoTitle: "After Hospital Discharge: Reablement and Home Care | KCG",
    seoDescription: "Understand reablement, short-term support and ongoing home care after hospital discharge, with safe questions for families preparing for the first week home.",
    image: "/images/blog/generated/hospital-discharge-reablement-home-care.svg",
    imageAlt: "A packed hospital bag, discharge folder, kettle and home key near a front door for planning support after coming home from hospital.",
    body: markdownToBlocks("Coming home from hospital can feel like a relief and a shock at the same time. The person may be glad to be back in their own chair, with their own kettle and familiar rooms. The family may still be worrying about meals, washing, confidence, stairs, medicines, appointments and what happens when short-term help ends.\n\nThis guide is for that first practical question: what kind of support might be needed at home, and who should you ask? It does not replace discharge advice, therapy advice, medical advice or council decisions. It helps families separate the routes so the right questions go to the right people.\n\n## Start with the discharge team\u2019s instructions\n\nBefore arranging anything privately, ask the hospital or discharge team what has already been agreed. Write down the answers rather than trying to remember everything in a busy corridor or phone call.\n\nAsk:\n- what support is expected when the person first gets home;\n- whether reablement, intermediate care or another short-term service has been discussed;\n- who is responsible for equipment, therapy exercises, wound care, medicines or follow-up appointments;\n- who the family should contact if the person becomes more unwell;\n- whether a council assessment or review is expected.\n\nIf the answer involves health, therapy, medicines, wounds, falls, urgent symptoms or clinical restrictions, keep it with NHS clinicians, pharmacists, therapists, the GP, NHS 111 or 999 as appropriate. A home-care provider should not be asked to interpret discharge instructions outside its role.\n\n## What reablement may mean\n\nNHS guidance describes short-term support after illness, injury or a hospital stay as help to recover and regain independence. People often use the word reablement for support that focuses on doing as much as possible safely and rebuilding confidence with everyday tasks.\n\nThe exact service, length and route can vary by local area and personal circumstances. Do not assume the same pathway applies in every council area or after every hospital stay.\n\nUseful questions to ask the discharge or council team include:\n- Is reablement or short-term support being arranged?\n- Who provides it locally?\n- What is it meant to help with?\n- How long is it expected to last?\n- What review happens before it ends?\n- Who should family contact if the person is struggling more than expected?\n\n## Where ongoing home care may fit\n\nOngoing home care is different from clinical discharge planning. It may help with practical daily routines such as getting washed and dressed, preparing simple meals, prompting agreed routines, helping someone settle in the evening, companionship, or keeping family informed within an agreed care plan.\n\nIt should not be sold as a way to speed discharge, replace therapy, prevent readmission, guarantee recovery or take over clinical responsibilities. If someone needs nursing, rehabilitation, medication advice, equipment decisions or urgent health assessment, that belongs with the relevant professional route.\n\nA safer way to frame the question is: what everyday support might still be needed once hospital, NHS or council arrangements are clear?\n\n## First week home checklist\n\nUse this checklist for family notes. Bring it to calls with the discharge team, council team or a care provider, depending on the question.\n\nPractical routine:\n- Can the person get up, wash, dress and eat safely with the current plan?\n- Are mornings or evenings the hardest part of the day?\n- Is there food in the house that the person can realistically manage?\n- Are there appointments, prescriptions or follow-up calls already booked?\n\nHome environment:\n- Is the route from bedroom to bathroom clear?\n- Has equipment been delivered or explained by the right professional?\n- Are keys, access, heating and phone charging sorted?\n- Does the family know who can enter the home and when?\n\nFamily pressure:\n- Who is staying nearby in the first few days?\n- Which relative is doing calls, meals, laundry or appointments?\n- What is too much for family to keep doing safely?\n- Who needs updates if relatives live outside the area?\n\nCare-provider questions:\n- What support is within the provider\u2019s role?\n- What needs to stay with clinicians, therapists, pharmacists or the council?\n- Can visit times and tasks be written down clearly?\n- How are changes or concerns recorded and escalated?\n\n## North East signposting without assumptions\n\nFor families in Newcastle, North Tyneside, Gateshead, Northumberland or the Tyne Valley, discharge and reablement arrangements may involve different NHS, hospital and council routes. Check the specific information given by the hospital and the relevant local authority rather than relying on a generic article.\n\nKCG can have a care conversation about practical support in its service area, but that conversation should sit alongside, not replace, the discharge team\u2019s instructions or council assessment route.\n\n## When to get urgent help\n\nIf the person is suddenly more unwell, has severe symptoms, may be seriously injured, or there is a risk to life, use the appropriate urgent route. NHS 111 is for urgent medical help that is not life-threatening. Call 999 in a medical emergency.\n\nIf the concern is not urgent but something is not working at home, write down what happened, when it happened, who was present, and which team has responsibility for that part of support. Clear notes make the next call much easier.\n\n## A cautious next step\n\nThe best first week home is not built on heroic family guesswork. It is built on clear instructions, written responsibilities and support that matches the person\u2019s real day.\n\nIf ongoing practical support may be needed after discharge, request a care conversation with KCG and keep that conversation separate from clinical discharge advice: /request-care. You can also check whether the address sits in KCG\u2019s service area: /where-we-operate"),
    sources: [
      {"title": "NHS, Care after a hospital stay", "url": "https://www.nhs.uk/social-care-and-support/care-after-a-hospital-stay/"},
      {"title": "NHS, Care to support recovery after leaving hospital", "url": "https://www.nhs.uk/social-care-and-support/care-after-a-hospital-stay/care-to-support-recovery-after-leaving-hospital-or-after-a-fall-injury-or-illness/"},
      {"title": "NHS, Help at home from a paid carer", "url": "https://www.nhs.uk/social-care-and-support/care-services-equipment-and-care-homes/homecare/"},
      {"title": "NHS, Getting a care needs assessment", "url": "https://www.nhs.uk/social-care-and-support/help-from-social-services-and-charities/getting-a-needs-assessment/"},
      {"title": "NHS, When to use NHS 111 online or call 111", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-use-111/"},
      {"title": "NHS, When to call 999", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-call-999/"}
    ],
    cta: "If ongoing practical support may be needed after discharge, request a care conversation and keep it separate from clinical discharge advice: /request-care",
    safetyNote: "This article is general information, not medical, discharge, rehabilitation or emergency advice. Hospital, NHS, therapy and council teams handle clinical discharge planning, reablement pathways and urgent health decisions. For urgent medical help, use NHS 111 or 999 as appropriate.",
  },

  "how-much-does-home-care-cost-in-the-uk-and-what-affects-price": {
    title: "How Much Does Home Care Cost in the UK, and What Affects the Price?",
    slug: "home-care-costs-uk",
    excerpt: "A practical, no-price-promise guide to what can affect UK home-care costs, what families should ask before comparing quotes, and where council funding questions belong.",
    category: "Funding & Planning",
    seoTitle: "How Much Does Home Care Cost in the UK? What Affects Price",
    seoDescription: "Learn what can affect home-care costs in the UK, how to compare quotes safely, and why council assessment and financial advice questions should stay separate.",
    image: "/images/blog/generated/home-care-costs-uk.svg",
    imageAlt: "A household notebook, calculator, care folder and tea mug on a kitchen table for comparing home-care cost questions.",
    body: markdownToBlocks("Families often ask \u201chow much does home care cost?\u201d when what they really need is a safer question: what could change the cost for this person, in this home, with these visits, and who decides any council support?\n\nThis article does not give KCG prices or personalised financial advice. Prices can change, quotes depend on the support being discussed, and council help depends on assessment routes and individual circumstances. Use this as a list of questions to ask before relying on any figure you see online.\n\n## Separate three money questions\n\nHome-care costs can become confusing because three different questions get mixed together.\n\nQuestion one: what support does the person need? That is about daily life, risk, preferences, family support and what can be done safely.\n\nQuestion two: what would a provider charge for a proposed care arrangement? That is about visits, timing, location, tasks, supervision, cancellation terms and review arrangements.\n\nQuestion three: whether the council may contribute or arrange support. That sits with council assessment and financial assessment routes, not with a private provider\u2019s sales conversation.\n\nKeeping those questions separate makes the conversation calmer.\n\n## What can affect a home-care quote?\n\nDo not compare providers only by a headline hourly rate. Ask what the quote actually includes.\n\nThe cost may be affected by:\n- visit length and number of visits each week;\n- time of day, weekends or bank holidays;\n- where the person lives and how travel is planned;\n- whether two care workers are required for any task;\n- the complexity of the support being discussed;\n- whether support includes personal care, meals, companionship or household tasks;\n- supervision, reviews and care-plan updates;\n- notice periods, cancellations and changes;\n- whether needs are likely to change quickly.\n\nA cheaper-looking arrangement is not automatically better if visits are too short for the person to be supported safely and respectfully. A more expensive-looking arrangement is not automatically better either. Ask for the reasoning.\n\n## Questions to ask before comparing quotes\n\nUse the same questions with every provider you speak to.\n\nCare arrangement:\n- What visit pattern are you quoting for?\n- What tasks are included in each visit?\n- What is not included?\n- How will the care plan be reviewed if needs change?\n\nCost clarity:\n- What is charged by visit, hour or another unit?\n- Are evenings, weekends or bank holidays different?\n- Are travel, mileage or administration costs included or separate?\n- What happens if a visit is cancelled, shortened or extended?\n- How are price changes communicated?\n\nSafety and scope:\n- Would any task require two care workers or another professional route?\n- Which medication or health questions must go to a pharmacist, GP or clinician?\n- What happens if the provider believes the proposed visit length is not safe or realistic?\n\nWritten information:\n- Can we have the proposed care arrangement and costs in writing?\n- Who should family contact about routine changes?\n- How are complaints or billing questions handled?\n\n## Council funding and direct payments\n\nNHS guidance explains that councils may help with social care costs depending on assessments and financial circumstances. GOV.UK also explains direct payments as one route where eligible people receive money to arrange support themselves.\n\nDo not assume council support will or will not be available from an article, a neighbour\u2019s experience or a provider conversation. Ask the relevant local council about assessment and financial assessment routes. If you need benefits, debt, legal or financial advice, use an appropriate independent advice service.\n\nFor North East families, that may mean checking Newcastle, North Tyneside, Gateshead or Northumberland adult social care information depending on where the person lives.\n\n## Be careful with online price lists\n\nOnline articles can be useful for understanding why costs vary, but they can go out of date quickly or describe a different area, service type or level of support. Sector reports can give context, but they are not a personal quote and they are not KCG\u2019s price list.\n\nIf a provider publishes prices, still ask what is included. If a provider does not publish prices, ask for a clear explanation before agreeing to anything.\n\n## A practical next step\n\nBefore you request a quote, write down the real routine:\n- what help is needed in the morning;\n- what help is needed with meals or drinks;\n- whether personal care is involved;\n- whether family can cover some tasks;\n- what needs professional, council or clinical input;\n- what would make support feel respectful rather than rushed.\n\nThen ask providers to explain the arrangement, not just the price.\n\nIf you are considering KCG, request a care conversation rather than relying on generic price assumptions: /request-care. You can also check whether the address is in the current service area: /where-we-operate"),
    sources: [
      {"title": "NHS, When the council might pay for your social care", "url": "https://www.nhs.uk/social-care-and-support/money-work-and-benefits/when-the-council-might-pay-for-your-care/"},
      {"title": "GOV.UK, Apply for direct payments", "url": "https://www.gov.uk/apply-direct-payments"},
      {"title": "Age UK, Paying for care at home", "url": "https://www.ageuk.org.uk/information-advice/care/paying-for-care/paying-for-homecare/"},
      {"title": "Which?, Paying for care at home", "url": "https://www.which.co.uk/money/pensions-and-retirement/financing-later-life-care/paying-for-care-at-home-aLGNI2T1NhwY"},
      {"title": "Citizens Advice, Benefits", "url": "https://www.citizensadvice.org.uk/benefits/"},
      {"title": "Homecare Association, Minimum Price for Homecare", "url": "https://www.homecareassociation.org.uk/resource/minimum-price-for-homecare.html"}
    ],
    cta: "Ask for a clear explanation of what is included in any quote. If you are considering KCG, request a care conversation rather than relying on generic price assumptions: /request-care",
    safetyNote: "This article is general information, not financial, benefits, legal or council advice. It does not publish KCG prices or personalised cost guidance. Council support, financial assessments, direct payments, benefits and legal questions should be checked with the relevant council or independent advice service.",
  },

  "what-to-do-if-care-visits-are-late-rushed-or-missed": {
    title: "What to Do If Home Care Visits Are Late, Rushed or Missed",
    slug: "late-missed-rushed-home-care-visits",
    excerpt: "A calm guide for families on recording late, rushed or missed home-care visits, raising concerns with a provider, and knowing when safety or safeguarding routes may be needed.",
    category: "Choosing Care",
    seoTitle: "What to Do If Home Care Visits Are Late, Rushed or Missed",
    seoDescription: "Learn what families can record, ask and escalate if home-care visits are late, rushed or missed, with CQC, Age UK and safety signposting.",
    image: "/images/blog/generated/late-missed-rushed-home-care-visits.svg",
    imageAlt: "A care visit log, clock, phone and pen on a side table for recording late, rushed or missed home-care visits.",
    body: markdownToBlocks("Late, rushed or missed home-care visits are not small admin problems when someone depends on support to get up, eat, wash, take part in the day or feel safe at home. They can leave families angry, anxious and unsure who to call.\n\nThis guide does not decide whether something is neglect, a safeguarding issue or a legal claim. It helps you record what happened, raise it clearly, and know when to use urgent or safeguarding routes.\n\n## Start with safety\n\nIf the person is in immediate danger, there is a risk to life, or urgent medical help is needed, use emergency or urgent NHS routes rather than waiting for an email reply from a provider. Call 999 in an emergency. Use NHS 111 for urgent medical help that is not life-threatening.\n\nIf the concern may be about abuse, neglect or a person being unable to protect themselves from harm, contact the local council adult safeguarding route. If you are unsure, it is safer to ask the council route than to minimise the concern.\n\nFor non-urgent reliability problems, record the facts and contact the provider through its normal concern or complaints process.\n\n## Write down what happened\n\nEmotional calls are understandable, but clear notes get better answers. Use this simple log.\n\nFor each concern, record:\n- date;\n- scheduled visit time;\n- actual arrival time, if the visit happened;\n- how long the visit lasted;\n- what support was expected;\n- what support was missed, rushed or changed;\n- who was present;\n- whether the person was left without food, drink, personal care, medication support within the care plan, heating, access or reassurance;\n- who you contacted and when;\n- what response you received.\n\nKeep messages, call notes and care records where you are entitled to have them. Do not edit the story later to make it sound stronger. Facts are enough.\n\n## Speak to the provider first where appropriate\n\nFor routine concerns, start with the provider. CQC expects providers to receive and act on complaints, and a good provider should be able to explain how concerns are handled.\n\nAsk:\n- Why was the visit late, rushed or missed?\n- When did the provider know there was a problem?\n- Who should have contacted the person or family?\n- What immediate action has been taken?\n- Is the care plan realistic for the visit length?\n- Does the rota allow enough travel time?\n- How will this be recorded and reviewed?\n- What changes will prevent the same issue happening again?\n\nAsk for the answer in writing if the issue affects safety, dignity, costs, trust or whether care should continue.\n\n## If visits feel rushed\n\nA visit can happen on time and still feel wrong. Rushed care may mean the planned tasks do not fit the visit length, the care plan is unclear, the person\u2019s preferences are being missed, or staff are under pressure.\n\nQuestions to ask include:\n- What exactly is meant to happen in this visit?\n- Which tasks are essential and which are flexible?\n- Is the visit length realistic for personal care, meals or mobility needs?\n- Has the person\u2019s routine changed since the plan was written?\n- Would a different visit pattern be safer or more respectful?\n\nAvoid asking care workers to squeeze unsafe amounts of support into a short slot. Raise the planning issue with the provider.\n\n## If a visit is missed\n\nA missed visit needs a clear explanation and a clear response. Ask when the provider became aware, what backup process should have started, and how the person was kept safe.\n\nIf the person lives alone or relies on support for essential daily needs, do not wait for a vague update. Use the contact route in the care agreement or care plan. If the situation is urgent, use urgent services.\n\n## When to escalate beyond the first call\n\nEscalation may be needed if:\n- the provider does not respond;\n- the same problem keeps happening;\n- the explanation does not match the records;\n- the person is frightened, unsafe or losing trust;\n- family members are being asked to cover gaps without a plan;\n- the care plan no longer matches the person\u2019s needs.\n\nUse the provider\u2019s complaints process. If the concern relates to regulated care quality, CQC explains how people can share information or complain about a service. CQC does not usually resolve individual complaints for you, but information from people using services helps it understand risk.\n\nAge UK also has guidance on problems with homecare, which can be useful when families are deciding what to do next.\n\n## Questions for a future provider\n\nIf unreliable care has made you compare other providers, ask practical questions before changing.\n\nAsk:\n- How do you plan travel time between visits?\n- What happens if a carer is delayed or off sick?\n- Who contacts the person or family, and when?\n- How are visit notes recorded?\n- How are missed visits reviewed?\n- How do you decide whether a visit length is realistic?\n- What is your complaints process?\n\nDo not look for a provider that promises nothing will ever go wrong. Look for one that explains planning, records, communication and learning clearly.\n\nIf you are comparing providers after unreliable care, bring your reliability questions to a care conversation with KCG and ask exactly how visits are planned, recorded and reviewed: /request-care. You can also check KCG\u2019s service area first: /where-we-operate"),
    sources: [
      {"title": "CQC, Regulation 16: Receiving and acting on complaints", "url": "https://www.cqc.org.uk/guidance-regulation/providers/regulations-service-providers-and-managers/health-social-care-act/regulation-16"},
      {"title": "CQC, Complain about a service or provider", "url": "https://www.cqc.org.uk/contact-us/how-complain/complain-about-service-or-provider"},
      {"title": "CQC, What can you expect from a good home-care agency?", "url": "https://www.cqc.org.uk/care-services/what-expect-good-care-service/what-can-you-expect-good-home-care-agency"},
      {"title": "Age UK, Problems with homecare", "url": "https://www.ageuk.org.uk/information-advice/care/problems-with-care/problems-with-homecare/"},
      {"title": "NHS, When to use NHS 111 online or call 111", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-use-111/"},
      {"title": "NHS, When to call 999", "url": "https://www.nhs.uk/nhs-services/urgent-and-emergency-care-services/when-to-call-999/"}
    ],
    cta: "If you are comparing providers after unreliable care, bring your reliability questions to a care conversation and ask exactly how visits are planned, recorded and reviewed: /request-care",
    safetyNote: "This article is general information, not legal, safeguarding, regulatory or medical advice. If someone is in immediate danger or there is a risk to life, call 999. If there may be a safeguarding concern, contact the local council adult safeguarding route. For urgent medical concerns that are not life-threatening, use NHS 111.",
  }
};

const postSlots = [
  { key: 'weekend', offset: 0, author: null },
  { key: 'tuesday', offset: 1, author: 'Netty' },
  { key: 'thursday', offset: 3, author: 'Kieron' },
];

const baseDate = new Date('2025-05-05T00:00:00Z');

const addDays = (date, days) => {
  const next = new Date(date);
  next.setUTCDate(next.getUTCDate() + days);
  return next;
};

const formatDisplayDate = (date) =>
  new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);

const estimateReadTime = (body) => {
  const text = body
    .flatMap((block) => block.children || [])
    .flatMap((child) => child.children || [child])
    .map((child) => child.text || '')
    .join(' ');
  const words = text.split(/\s+/).filter(Boolean).length;
  return `${Math.max(4, Math.ceil(words / 220))} min read`;
};

const getExcerpt = (title, category) => {
  if (category === 'Care Careers') {
    return `A practical KCG guide for people considering care work, covering expectations, values, checks and what good home care requires.`;
  }

  return `A UK-focused home care guide for families: what to ask, what to check and how to make a confident decision about ${title.toLowerCase()}.`;
};

const getSeoDescription = (title, category) => {
  if (category === 'Care Careers') {
    return `${title} explained for care job applicants, with realistic expectations, checks, training and values-led home care guidance from KCG.`;
  }

  return `${title} explained for UK families arranging home care, with practical questions, CQC and NHS source links, and clear no-medical-advice boundaries.`;
};

const buildPost = (week, slot) => {
  const rawTitle = week[slot.key];
  if (!rawTitle) return null;

  const title = cleanTitle(rawTitle);
  const category = inferCategory(rawTitle);
  const seed = getTextSeed(title) + week.week * 10 + slot.offset;
  const body = createBody({ title, category, cta: week.cta, seed });
  const date = addDays(baseDate, (week.week - 1) * 7 + slot.offset);
  const author = slot.author || (week.week % 4 === 0 ? 'Kieron' : 'Netty');
  const post = {
    id: `plan-week-${week.week}-${slot.key}`,
    slug: slugify(title),
    title,
    excerpt: getExcerpt(title, category),
    body,
    author,
    authorName: author,
    publishedAt: date.toISOString().slice(0, 10),
    date: formatDisplayDate(date),
    readTime: estimateReadTime(body),
    image: getBlogImageForPost(category, title, seed),
    imageAlt: `${category} guide from KCG`,
    category,
    featured: false,
    seoTitle: `${title} | KCG UK Home Care Guide`,
    seoDescription: getSeoDescription(title, category),
    sources: getSourcesForPost(rawTitle, category),
    cta: week.cta,
  };
  const override = pilotBlogPostOverrides[post.slug];

  if (!override) return post;

  return {
    ...post,
    ...override,
    readTime: estimateReadTime(override.body),
    image: override.image || getBlogImageForPost(override.category, override.title, seed),
    imageAlt: override.imageAlt || `${override.category} guide from KCG`,
  };
};

export const fallbackBlogPosts = calendarWeeks
  .flatMap((week) => postSlots.map((slot) => ({ week, slot })))
  .map(({ week, slot }) => buildPost(week, slot))
  .filter(Boolean)
  .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
  .map((post, index) => ({
    ...post,
    featured: index === 0,
  }));

export const rebuiltBlogPostSlugAliases = Object.freeze(
  Object.fromEntries(
    Object.entries(pilotBlogPostOverrides).map(([originalSlug, post]) => [
      originalSlug,
      post.slug,
    ])
  )
);

export const rebuiltFallbackBlogPosts = fallbackBlogPosts.filter((post) =>
  Object.values(rebuiltBlogPostSlugAliases).includes(post.slug)
);

export const getRebuiltFallbackPostBySlug = (slug) =>
  rebuiltFallbackBlogPosts.find((post) => post.slug === slug) ||
  rebuiltFallbackBlogPosts.find(
    (post) => rebuiltBlogPostSlugAliases[slug] === post.slug
  ) ||
  null;

export const mergeRebuiltFallbackPosts = (posts = []) => {
  const merged = posts.map((post) => getRebuiltFallbackPostBySlug(post.slug) || post);
  const seen = new Set(merged.map((post) => post.slug));

  rebuiltFallbackBlogPosts.forEach((post) => {
    if (!seen.has(post.slug)) {
      merged.push(post);
      seen.add(post.slug);
    }
  });

  return merged;
};

export const fallbackBlogPlan = calendarWeeks;
